(function(){
  if (window.__WIMMELBUCH_CONFIG_LOADED__) return;
  window.__WIMMELBUCH_CONFIG_LOADED__ = true;

class WimmelbuchConfigButton extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector('button');
    this.boldText = this.querySelector('b');
    this.dialog = document.querySelector('trainingbook-config-dialog') || document.querySelector('wimmelbuch-config-dialog');
    if (!this.dialog) {
      this.dialog = document.querySelector('dog-talk-config-dialog');
    }
    if (!this.dialog) {
      this.dialog = document.querySelector('malbuch-config-dialog');
    }
    this.button.addEventListener('click', this.handleClicked.bind(this));

    if (!this.dialog.completed) {
      this.button.classList.remove('button--tertiary');
      this.button.classList.add('button--primary');
    }

  }

  setCompleted() {
    this.boldText.innerHTML = 'Personalisierung anpassen';
    this.button.classList.remove('button--primary');
    this.button.classList.add('button--tertiary');

  }

  handleClicked(e) {
    e.preventDefault();
    if (!this.dialog) {
      // Try to locate again in case it was mounted after button
      this.dialog = document.querySelector('wimmelbuch-config-dialog') || document.querySelector('dog-talk-config-dialog') || document.querySelector('malbuch-config-dialog');
    }
    if (!this.dialog) {
      console.warn('Configurator dialog not found');
      return;
    }
    const api = this.dialog;
    if (typeof api.toggleDialog === 'function') {
      api.toggleDialog();
    } else if (typeof api.showStep === 'function') {
      // web component not upgraded yet: manually display wrapper
      const wrapper = api.querySelector('.product-wimmelbuch__config--dialog');
      if (wrapper) wrapper.style.display = 'flex';
      api.showStep(1);
    } else {
      const wrapper = api.querySelector('.product-wimmelbuch__config--dialog');
      if (wrapper) wrapper.style.display = 'flex';
    }
  }
}

if (!customElements.get('wimmelbuch-config-button')) {
  customElements.define('wimmelbuch-config-button', WimmelbuchConfigButton);
}

class WimmelbuchConfigInputBreed extends HTMLElement {
  constructor() {
    super();
    this.inputElement = this.querySelector('input');
    this.autoCompleteContainer = this.querySelector('.product-wimmelbuch__config--input-breed__autocomplete-container');
    this.buttonNext = document.querySelector('.product-wimmelbuch__config--dialog__button__next');

    this.inputElement.addEventListener('blur', this.hideAutocomplete.bind(this));
    this.inputElement.addEventListener('focus', this.showAutocomplete.bind(this));

    this.inputElement.addEventListener('input', this.handleInputChange.bind(this));
    this.handleInputChange();
  }

  handleInputChange() {
    this.autoCompleteContainer.innerHTML = '';
    const filteredData = this.inputElement.value == '' ? window.wimmelBuchConfig : window.wimmelBuchConfig.filter(item => item.animal.toLowerCase().includes(this.inputElement.value.toLowerCase()));
    
    filteredData.sort((a, b) => a.animal.localeCompare(b.animal));

    this.handleNameInput();
    for (const item of filteredData) {
      const option = document.createElement('div');
      option.className = 'product-wimmelbuch__config--input-breed__autocomplete-option';
      const img = document.createElement('img');
      img.src = item.icon;
      img.alt = `${item.animal}`;
      img.className = "product-wimmelbuch__config--input-breed__autocomplete-option-icon";

      option.appendChild(img);
      option.appendChild(document.createTextNode(`${item.animal}`));
      option.dataset.id = item.name;

      option.addEventListener('click', () => {
        this.inputElement.value = item.animal;
        this.autoCompleteContainer.innerHTML = '';
        this.handleNameInput();
      });

      this.autoCompleteContainer.appendChild(option);
    }
  }

  handleNameInput() {
    const exists = window.wimmelBuchConfig.some(item => item.animal.toLowerCase().trim() == this.inputElement.value.toLowerCase().trim())
    if (!exists) {
      this.buttonNext.disabled = true;
    } else {
      this.buttonNext.disabled = false;
    }
  }

  showAutocomplete() {
    this.autoCompleteContainer.style.display = 'block';
  }

  hideAutocomplete() {
    setTimeout(() => {
      this.autoCompleteContainer.style.display = 'none';
    }, 200);
  }
}

if (!customElements.get('wimmelbuch-config-input-breed')) {
  customElements.define('wimmelbuch-config-input-breed', WimmelbuchConfigInputBreed);
}

class WimmelbuchConfigInputShape extends WimmelbuchConfigInputBreed {
  constructor() {
    super();
    this.inputElement = this.querySelector('input');
    this.autoCompleteContainer = this.querySelector('.product-wimmelbuch__config--input-breed__autocomplete-container');
    this.buttonNext = document.querySelector('.product-wimmelbuch__config--dialog__button__next');

    this.inputElement.addEventListener('blur', this.hideAutocomplete.bind(this));
    this.inputElement.addEventListener('focus', this.showAutocomplete.bind(this));

    this.inputElement.addEventListener('input', this.handleInputChange.bind(this));
    this.handleInputChange();
  }

}

if (!customElements.get('wimmelbuch-config-input-shape')) {
  customElements.define('wimmelbuch-config-input-shape', WimmelbuchConfigInputShape);
}

class WimmelbuchConfigInput extends HTMLElement {
  constructor() {
    super();
    this.inputElement = this.querySelector('input');
    this.buttonNext = document.querySelector('.product-wimmelbuch__config--dialog__button__next');

    this.inputElement.addEventListener('input', this.handleInputChange.bind(this));
    this.handleInputChange();
  }

  handleInputChange() {
    const exists = this.inputElement.value.toLowerCase().trim().length > 0
    if (!exists) {
      this.buttonNext.disabled = true;
    } else {
      this.buttonNext.disabled = false;
    }
  }

}

if (!customElements.get('wimmelbuch-config-input')) {
  customElements.define('wimmelbuch-config-input', WimmelbuchConfigInput);
}

class WimmelbuchConfigDialog extends HTMLElement {
  constructor() {
    super();
    this.showDialog = false;
    this.step = 1;
    this.completed = false;
    this.breedInput = this.querySelector('#product-wimmelbuch__config--dialog__input-breed');
    this.nameInput = this.querySelector('#product-wimmelbuch__config--dialog__input-name');
    this.buttonNext = this.querySelector('.product-wimmelbuch__config--dialog__button__next');
    this.buttonBack = this.querySelector('.product-wimmelbuch__config--dialog__button__back');
    this.dialogStep1 = this.querySelector('#product-wimmelbuch__config--dialog__step-1');
    this.dialogStep2 = this.querySelector('#product-wimmelbuch__config--dialog__step-2');
    this.selectElement = this.querySelector("wimmelbuch-config-select-element");

    this.dialogStep3 = this.querySelector('#product-wimmelbuch__config--dialog__step-3');
    this.stepTextp = this.querySelector('.product-wimmelbuch__config--dialog__heading-step-text');
    this.dialogStep3.style.display = 'none';
    this.dialogStep2.style.display = 'none';

    this.selectedColor = null;
    this.inputCounter = this.querySelector("#product-wimmelbuch__input-counter");
    this.handleEvents();

    this.buttonNext.addEventListener('click', (e) => { e.preventDefault(); this.nextStep(); });
    this.buttonBack.addEventListener('click', (e) => { e.preventDefault(); this.previousStep(); });


    if (this.nameInput) {
      this.nameInput.addEventListener('input', this.handleNameInput.bind(this));
    }
  }

  handleEvents() {
    this.selectElement.addEventListener('change', (e) => {
      this.selectedColor = e.target.value;
      this.buttonNext.disabled = false;
    });
  }

  handleNameInput() {
    if (this.nameInput.value == '' || this.nameInput.value.length <= 1) {
      this.buttonNext.disabled = true;
    } else {
      this.buttonNext.disabled = false;
    }
    this.inputCounter.innerHTML = `${this.nameInput.value.length}/14`;
  }

  saveOrder() {
    const config = window.wimmelBuchConfig.find(item => item.animal == this.breedInput.value);
    const color = config.colors[parseInt(this.selectedColor)];


    const order = {
      breed: this.breedInput.value,
      name: this.nameInput.value,
      image_hc: color.image_hc,
      image_sc: color.image_sc,
    };
    document.querySelectorAll("wimmelbuch-config-button").forEach(btn => btn.setCompleted());
    document.querySelector("wimmelbuch-stick-atc").setCompleted();
    document.querySelector('wimmelbuch-media-gallery').changeImage(order, color);
    document.querySelector("#wimmelbuchAtcButton").style.display = "block";
    document.querySelector('[name="properties[_wimmelbuch_animal]"]').value = color.handle;
    document.querySelector('[name="properties[_wimmelbuch_name]"]').value = order.name.trim();
    document.querySelector('[name="properties[_wimmelbuch_color]"]').value = color.name.trim();
    document.querySelector('[name="properties[_wimmelbuch_image]"]').value = color.image_hc;
    window.scrollTo(0, 0);
    document.querySelector("media-gallery").setActiveMedia(document.querySelector(".product__media-list li").dataset.mediaId)
  }

  nextStep() {
    if (this.step == 2) {
      this.step++;
      this.stepTextp.innerHTML = this.step;
      this.buttonNext.innerHTML = 'Konfigurieren';
      this.buttonNext.disabled = true;

      this.dialogStep2.style.display = 'none';
      this.dialogStep3.style.display = 'block';
      this.handleNameInput();
    } else if (this.step == 1) {
      this.step++;
      this.stepTextp.innerHTML = this.step;
      this.selectedColor = null;
      const config = window.wimmelBuchConfig.find(item => item.animal == this.breedInput.value);
      document.querySelector('wimmelbuch-config-select-element').setElements(config.colors, this.selectedColor);
      this.dialogStep1.style.display = 'none';
      this.dialogStep2.style.display = 'block';
      if (this.selectedColor == null) {
        this.buttonNext.disabled = true;
      } else {
        this.buttonNext.disabled = false;
      }


    } else if (this.step == 3) {
      this.toggleDialog();
      this.completed = true;
      this.saveOrder();
    }
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'event': 'wimmelbuch_step',
      'step': this.step
    });
  }

  previousStep() {
    this.buttonBack.blur();
    if (this.step == 1) {
      this.toggleDialog();
    } else if (this.step == 2) {
      this.step--;
      this.handleNameInput();
      this.dialogStep1.style.display = 'block';
      this.dialogStep3.style.display = 'none';
      this.dialogStep2.style.display = 'none';
      this.stepTextp.innerHTML = this.step;
      if (!this.breedInput.value) {
        this.buttonNext.disabled = true;
      } else {
        this.buttonNext.disabled = false;
      }
    } else if (this.step == 3) {
      this.completed = false;

      if (this.selectedColor == null) {
        this.buttonNext.disabled = true;
      } else {
        this.buttonNext.disabled = false;
      }

      this.buttonNext.innerHTML = 'Weiter';

      this.dialogStep2.style.display = 'block';
      this.dialogStep3.style.display = 'none';
      this.step--;
      this.stepTextp.innerHTML = this.step;
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        'event': 'wimmelbuch_step',
        'step': this.step
      });
    }
  }

  toggleDialog() {
    this.showDialog = !this.showDialog;
    this.querySelector('.product-wimmelbuch__config--dialog').style.display = this.showDialog ? 'flex' : 'none';
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'event': 'wimmelbuch_toggle',
      'open': this.showDialog
    })
  }
}

if (!customElements.get('wimmelbuch-config-dialog')) {
  customElements.define('wimmelbuch-config-dialog', WimmelbuchConfigDialog);
}


class DogTalkConfigDialog extends WimmelbuchConfigDialog {
  constructor() {
    super();
    this.dialogStep4 = this.querySelector('#product-wimmelbuch__config--dialog__step-4');
    this.dialogStep4.style.display = 'none';
    this.selectShape = this.querySelector("#product-wimmelbuch__config--dialog__step-3 wimmelbuch-config-input-shape");
    this.shapeInput = this.querySelector('#product-wimmelbuch__config--dialog__input-shape');
    this.selectColor = this.querySelector("#product-wimmelbuch__config--dialog__step-4 wimmelbuch-config-select-element");
    this.inputCounterBreed = this.querySelector("#product-wimmelbuch__input-breed-counter");
  



    this.selectColor.addEventListener('change', (e) => {
      this.selectedColor = e.target.value;
      this.buttonNext.disabled = false;
    });

    if (this.breedInput) {
      this.breedInput.addEventListener('input', this.handleBreedInput.bind(this));
    }

  }

  handleInput(){
    if (this.nameInput.value.length == 0) {
      this.buttonNext.disabled = true;
    } else {
      this.buttonNext.disabled = false;
    }
    this.inputCounter.innerHTML = `${this.nameInput.value.length}/14`;
  }

  handleBreedInput(){
    if (this.breedInput.value.length == 0) {
      this.buttonNext.disabled = true;
    } else {
      this.buttonNext.disabled = false;
    }
    this.inputCounterBreed.innerHTML = `${this.breedInput.value.length}/14`;
  }

  
  handleEvents() {

  }

  nextStep() {
    if (this.step == 2) {
      this.step++;
      this.stepTextp.innerHTML = this.step;
      this.buttonNext.disabled = true;

      this.dialogStep2.style.display = 'none';
      this.dialogStep3.style.display = 'block';

      if (this.selectedColor == null) {
        this.buttonNext.disabled = true;
      } else {
        this.buttonNext.disabled = false;
      }
    } else if (this.step == 1) {
      this.step++;
      this.stepTextp.innerHTML = this.step;
      this.dialogStep1.style.display = 'none';
      this.dialogStep2.style.display = 'block';
      this.handleBreedInput();
     

    } else if (this.step == 3) {

      //this.selectedColor = null;
      this.step++;
      this.stepTextp.innerHTML = this.step;
      const config = window.wimmelBuchConfig.find(item => item.animal == this.shapeInput.value);
      document.querySelector('#product-wimmelbuch__config--dialog__step-4 wimmelbuch-config-select-element').setElements(config.colors, this.selectedColor);
      this.dialogStep3.style.display = 'none';
      this.dialogStep4.style.display = 'block';
      if (this.selectedColor == null) {
        this.buttonNext.disabled = true;
      } else {
        this.buttonNext.disabled = false;
      }

    } else if (this.step == 4) {

      this.toggleDialog();
      this.completed = true;
      this.saveOrder();
    }
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'event': 'wimmelbuch_step',
      'step': this.step
    });
  }

  previousStep() {
    this.buttonBack.blur();
    if (this.step == 1) {
      this.toggleDialog();
    } else if (this.step == 2) {
      this.step--;
      this.dialogStep1.style.display = 'block';
      this.dialogStep3.style.display = 'none';
      this.dialogStep2.style.display = 'none';
      this.stepTextp.innerHTML = this.step;
      this.handleNameInput();
    } else if (this.step == 3) {
      this.dialogStep1.style.display = 'none';
      this.dialogStep3.style.display = 'none'; 
      this.dialogStep2.style.display = 'block';

      this.handleBreedInput()
      this.step--;
      this.stepTextp.innerHTML = this.step;

    } else if (this.step == 4) {
      this.completed = false;

      this.buttonNext.disabled = false;
   
      this.buttonNext.innerHTML = 'Weiter';

      this.dialogStep3.style.display = 'block';
      this.dialogStep4.style.display = 'none';
      this.step--;
      this.stepTextp.innerHTML = this.step;
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        'event': 'wimmelbuch_step',
        'step': this.step
      });
    }
  }

  saveOrder() {
    const config = window.wimmelBuchConfig.find(item => item.animal == this.shapeInput.value);
    const colors = config.colors;
    const color = colors[parseInt(this.selectedColor)];

    const order = {
      owner: this.breedInput.value,
      name: this.nameInput.value,
      image_hc: color.image_hc,
      image_sc: color.image_sc,
    };
    document.querySelectorAll("wimmelbuch-config-button").forEach(btn => btn.setCompleted());
    document.querySelector("wimmelbuch-stick-atc").setCompleted();
    document.querySelector('dogtalk-media-gallery').changeImage(order, color);
    document.querySelector("#wimmelbuchAtcButton").style.display = "block";
    document.querySelector('[name="properties[_wimmelbuch_animal]"]').value = color.handle;
    document.querySelector('[name="properties[_wimmelbuch_name]"]').value = order.name.trim();
    document.querySelector('[name="properties[_wimmelbuch_owner]"]').value = order.owner.trim();
    document.querySelector('[name="properties[_wimmelbuch_color]"]').value = color.name.trim();
    if(color.image_hc.includes("no-image")){
      document.querySelector('[name="properties[_wimmelbuch_image]"]').value = color.image_sc;
    } else {
      document.querySelector('[name="properties[_wimmelbuch_image]"]').value = color.image_hc;
    }

    window.scrollTo(0, 0);
    document.querySelector("media-gallery").setActiveMedia(document.querySelectorAll(".product__media-list li")[1].dataset.mediaId)
  }
}
if (!customElements.get('dog-talk-config-dialog')) {
  customElements.define('dog-talk-config-dialog', DogTalkConfigDialog);
}

class MalbuchConfigDialog extends WimmelbuchConfigDialog {
  constructor() {
    super();
    this.dialogStep4 = this.querySelector('#product-wimmelbuch__config--dialog__step-4');
    this.dialogStep4.style.display = 'none';
    this.selectShape = this.querySelector("#product-wimmelbuch__config--dialog__step-1 wimmelbuch-config-input-shape");
    this.shapeInput = this.querySelector('#product-wimmelbuch__config--dialog__input-shape');
    this.selectColor = this.querySelector("#product-wimmelbuch__config--dialog__step-2 wimmelbuch-config-select-element");
    this.inputCounterBreed = this.querySelector("#product-wimmelbuch__input-breed-counter");
  
    this.selectColor.addEventListener('change', (e) => {
      this.selectedColor = e.target.value;
      this.buttonNext.disabled = false;
    });

    if (this.breedInput) {
      this.breedInput.addEventListener('input', this.handleBreedInput.bind(this));
    }

    if (this.shapeInput) {
      this.shapeInput.addEventListener('input', this.handleShapeInput.bind(this));
    }
  }

  handleInput(){
    if (this.nameInput.value.length == 0) {
      this.buttonNext.disabled = true;
    } else {
      this.buttonNext.disabled = false;
    }
    this.inputCounter.innerHTML = `${this.nameInput.value.length}/14`;
  }

  handleShapeInput(){
    if (this.shapeInput.value.length == 0) {
      this.buttonNext.disabled = true;
    } else {
      this.buttonNext.disabled = false;
    }
  }

  handleBreedInput(){
    if (this.breedInput.value.length == 0) {
      this.buttonNext.disabled = true;
    } else {
      this.buttonNext.disabled = false;
    }
    this.inputCounterBreed.innerHTML = `${this.breedInput.value.length}/14`;
  }

  
  handleEvents() {

  }

  nextStep() {
    if (this.step == 1) {
      this.step++;
      this.stepTextp.innerHTML = this.step;
      this.buttonNext.disabled = true;
      this.dialogStep1.style.display = 'none';
      this.dialogStep2.style.display = 'block';
      
      // Load color options based on selected breed
      const config = window.wimmelBuchConfig.find(item => item.animal == this.shapeInput.value);
      document.querySelector('#product-wimmelbuch__config--dialog__step-2 wimmelbuch-config-select-element').setElements(config.colors, this.selectedColor);
      if (this.selectedColor == null) {
        this.buttonNext.disabled = true;
      } else {
        this.buttonNext.disabled = false;
      }
    } else if (this.step == 2) {
      this.step++;
      this.stepTextp.innerHTML = this.step;
      this.buttonNext.disabled = true;
      this.dialogStep2.style.display = 'none';
      this.dialogStep3.style.display = 'block';
      this.handleInput();
     

    } else if (this.step == 3) {

      //this.selectedColor = null;
      this.step++;
      this.stepTextp.innerHTML = this.step;
      this.dialogStep3.style.display = 'none';
      this.dialogStep4.style.display = 'block';
     
    } else if (this.step == 4) {

      this.toggleDialog();
      this.completed = true;
      this.saveOrder();
    }
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'event': 'wimmelbuch_step',
      'step': this.step
    });
  }

  previousStep() {
    this.buttonBack.blur();
    if (this.step == 1) {
      this.toggleDialog();
    } else if (this.step == 2) {
      this.step--;
      this.dialogStep1.style.display = 'block';
      this.dialogStep3.style.display = 'none';
      this.dialogStep4.style.display = 'none';
      this.dialogStep2.style.display = 'none';
      this.stepTextp.innerHTML = this.step;
    } else if (this.step == 3) {
      this.dialogStep1.style.display = 'none';
      this.dialogStep3.style.display = 'none'; 
      this.dialogStep2.style.display = 'block';

      this.dialogStep3.style.display = 'none';
      this.dialogStep4.style.display = 'none';
      this.step--;
      this.stepTextp.innerHTML = this.step;

    } else if (this.step == 4) {
      this.completed = false;

      this.buttonNext.disabled = false;
   
      this.buttonNext.innerHTML = 'Weiter';
      this.dialogStep1.style.display = 'none';
      this.dialogStep2.style.display = 'none';
      this.dialogStep3.style.display = 'block';
      this.dialogStep4.style.display = 'none';
      this.step--;
      this.stepTextp.innerHTML = this.step;
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        'event': 'wimmelbuch_step',
        'step': this.step
      });
    }
  }

  saveOrder() {
    const config = window.wimmelBuchConfig.find(item => item.animal == this.shapeInput.value);
    const colors = config.colors;
    const color = colors[parseInt(this.selectedColor)];

    const order = {
      owner: this.breedInput.value,
      name: this.nameInput.value,
      image_hc: color.image_hc,
      image_sc: color.image_sc,
    };
    document.querySelectorAll("wimmelbuch-config-button").forEach(btn => btn.setCompleted());
    document.querySelector("wimmelbuch-stick-atc").setCompleted();
    document.querySelector('dogtalk-media-gallery').changeImage(order, color);
    document.querySelector("#wimmelbuchAtcButton").style.display = "block";
    document.querySelector('[name="properties[_wimmelbuch_animal]"]').value = color.handle;
    document.querySelector('[name="properties[_wimmelbuch_name]"]').value = order.name.trim();
    document.querySelector('[name="properties[_wimmelbuch_owner]"]').value = order.owner.trim();
    document.querySelector('[name="properties[_wimmelbuch_color]"]').value = color.name.trim();
    if(color.image_hc.includes("no-image")){
      document.querySelector('[name="properties[_wimmelbuch_image]"]').value = color.image_sc;
    } else {
      document.querySelector('[name="properties[_wimmelbuch_image]"]').value = color.image_hc;
    }

    window.scrollTo(0, 0);
    document.querySelector("media-gallery").setActiveMedia(document.querySelectorAll(".product__media-list li")[1].dataset.mediaId)
  }
}
if (!customElements.get('malbuch-config-dialog')) {
  customElements.define('malbuch-config-dialog', MalbuchConfigDialog);
}

class WimmelbuchTab extends HTMLElement {
  constructor() {
    super();
    this.tab = this.querySelector('.product-wimmelbuch__collapsible--header');
    this.tab.addEventListener('click', this.handleTabClick.bind(this));
  }

  handleTabClick() {
    const tabContent = this.querySelector('.product-wimmelbuch__collapsible--header');
    tabContent.classList.toggle('active');
  }
}

if (!customElements.get('wimmelbuch-tab')) {
  customElements.define('wimmelbuch-tab', WimmelbuchTab);
}


class WimmelbuchMediaGallery extends HTMLElement {
  constructor() {
    super();
    setTimeout(() => {
      const selectableImages = Array.from(document.querySelectorAll(".product__media-list img"))
      const isWimmelBuch = !selectableImages.some((img) => img.src.includes("if-my-dog-could-talk"))

      if (!isWimmelBuch) {
        const defaultOrder = {
          name: "Charly",
          breed: "Dobberman",
        }
        const defaultColor = {
          image_hc: document.querySelector(".wimmelbuch-layer-image image")?.getAttribute("href") || "",
          image_sc: document.querySelectorAll(".wimmelbuch-layer-image image")[1]?.getAttribute("href") || "",
        }
        this.changeImage(defaultOrder, defaultColor)
      }
    }, 100) // Small timeout to ensure DOM is ready
  }


  _enalbeLoading() {
    this.querySelector('.wimmelbuch-media-gallery__item .loader').display = 'block';
  }

  _disableLoading() {
    this.querySelector('.wimmelbuch-media-gallery__item .loader').display = 'none';
  }

  changeImage(order, color) {
    this.querySelectorAll('.wimmelbuch-overlay--text text').forEach(item => item.innerHTML = `${order.name}?`);
    const diff = (order.name.length - 8);
    if (diff > 0) {
      this.querySelectorAll('.wimmelbuch-overlay--text text').forEach(item => item.setAttribute("font-size", `${(36 - (diff * 2.25))}px`));
    } else {
      this.querySelectorAll('.wimmelbuch-overlay--text text').forEach(item => item.setAttribute("font-size", `36px`));
    }
    const images = Array.from(document.querySelectorAll('.wimmelbuch-layer-image image'));
    images[0]?.setAttribute('href', color.image_hc);
    images[1]?.setAttribute('href', color.image_sc);
    
    //const mainImages = Array.from(document.querySelectorAll('.wimmelbuch-layer-image image'));

  }
}

if (!customElements.get('wimmelbuch-media-gallery')) {
  customElements.define('wimmelbuch-media-gallery', WimmelbuchMediaGallery);
}

class DogTalkMediaGallery extends HTMLElement {
  constructor() {
    super();
    //this.addCornerCafeFont();
    setTimeout(() => {
      const selectableImages = Array.from(document.querySelectorAll(".product__media-list img"))
      const isWimmelBuch = !selectableImages.some((img) => img.src.includes("if-my-dog-could-talk"))

      if (!isWimmelBuch) {
        const defaultOrder = {
          name: "Charly",
          breed: "Dobberman",
        }
        const defaultColor = {
          image_hc: document.querySelector(".wimmelbuch-layer-image image")?.getAttribute("href") || "",
          image_sc: document.querySelectorAll(".wimmelbuch-layer-image image")[1]?.getAttribute("href") || "",
        }
        this.changeImage(defaultOrder, defaultColor)
      }
    }, 100) // Small timeout to ensure DOM is ready
  }

  addCornerCafeFont() {
    return;
    // Check if the font style is already added to avoid duplicates
    if (!document.getElementById('corner-cafe-font')) {
      const styleSheet = document.createElement("style");
      styleSheet.id = 'corner-cafe-font';
      
      // Try multiple possible paths to the font
      styleSheet.innerHTML = `
        @font-face {
          font-family: 'CornerCafe';
          src: url('CORNERCAFE-1J2W4.ttf') format('truetype');
          font-weight: normal;
          font-style: normal;
          font-display: swap;
        }
      `;
      document.head.appendChild(styleSheet);
    }
  }

  _enalbeLoading() {
    this.querySelector('.wimmelbuch-media-gallery__item .loader').display = 'block';
  }

  _disableLoading() {
    this.querySelector('.wimmelbuch-media-gallery__item .loader').display = 'none';
  }

  changeImage(order, color) {
    this.querySelectorAll('.wimmelbuch-overlay--text text').forEach(item => item.innerHTML = `${order.name}`);
    const diff = (order.name.length - 8);
    if (diff > 0) {
      this.querySelectorAll('.wimmelbuch-overlay--text text').forEach(item => item.setAttribute("font-size", `${(46 - (diff * 2.25))}px`));
    } else {
      this.querySelectorAll('.wimmelbuch-overlay--text text').forEach(item => item.setAttribute("font-size", `46px`));
    }
    const images = Array.from(document.querySelectorAll('.wimmelbuch-layer-image image'));
    if(color.image_hc.includes("no-image")){
      images[0]?.setAttribute('href', color.image_sc);
      images[1]?.setAttribute('href', color.image_sc);
    } else {
      images[0]?.setAttribute('href', color.image_hc);
      images[1]?.setAttribute('href', color.image_hc);      
    }
    
    //const mainImages = Array.from(document.querySelectorAll('.wimmelbuch-layer-image image'));

    const selectableImages = Array.from(document.querySelectorAll('.product__media-list img'));
    const isWimmelBuch = !selectableImages.some(img => img.src.includes("if-my-dog-could-talk"));

    if (!isWimmelBuch && false) {
      //this.addCornerCafeFont();

      if (selectableImages.length > 0) {
        const firstSelectableImage = selectableImages[0];
        const container = firstSelectableImage.parentElement;
        if (getComputedStyle(container).position === 'static') {
          container.style.position = 'relative';
        }
        
        let textOverlay = container.querySelector('.text-overlay');
        if (!textOverlay) { 
          textOverlay = document.createElement('div');
          textOverlay.className = 'text-overlay';
         
          textOverlay.style.position = 'absolute';
          textOverlay.style.top = '72%';
          textOverlay.style.left = '67%';
          textOverlay.style.transform = 'translate(-50%, -50%)';
          textOverlay.style.width = '100%';
          textOverlay.style.textAlign = 'center';
          textOverlay.style.fontSize = '36px';
          textOverlay.style.fontWeight = 'bold';
          textOverlay.style.color = 'rgb(158, 73, 56)';
          textOverlay.style.textShadow = '1px 1px 2px white';
          textOverlay.style.pointerEvents = 'none';
          textOverlay.style.fontFamily = "'CornerCafe', cursive";
          
          container.appendChild(textOverlay);
        }
        textOverlay.textContent = order.name.toUpperCase();
      }
    }
  }
}

if (!customElements.get('dogtalk-media-gallery')) {
  customElements.define('dogtalk-media-gallery', DogTalkMediaGallery);
}


class WimmelbuchConfigSelectElement extends HTMLElement {
  constructor() {
    super();
    
    this.name = this.getAttribute('name') || 'color';
  }

  setElements(elements, selectedColor) {
    var html = '<div class="grid grid--2-col grid--3-col-tablet">';
    elements.forEach((elem, index) => {
      html += `<div class="grid__item"><input type="radio" name="${this.name}" value="${index}" ${(index == selectedColor) ? 'checked' : ''} id="${this.name}-${index}" /><label for="${this.name}-${index}"><img src="${elem.icon}" /></label></div>`;
    });
    html += '</div>'


    this.innerHTML = html;

  }
}

if (!customElements.get('wimmelbuch-config-select-element')) {
  customElements.define('wimmelbuch-config-select-element', WimmelbuchConfigSelectElement);
}


class WimmelbuchStickAtc extends HTMLElement {
  constructor() {
    super();
    this.stickyAtc = this.querySelector('#stickyATC');
    this.stickyATCButton = this.querySelector('#stickyATCButton');
    this.stickyATCButton.addEventListener('click', () => {
      document.querySelector('#wimmelbuchAtcButton').click();
    });
    window.addEventListener('scroll', (event) => {
      let mainBTN = document.querySelector(
        '.product__info-wrapper .product-wimmelbuch__config--button:not(.product-wimmelbuch__AddToCart_Sticky)'
      ) // document.getElementById("mainATC");

      if (this.isOutOfViewport(mainBTN).any) {
        this.stickyAtc.classList.add('sticky')
      } else {
        this.stickyAtc.classList.remove('sticky')
      }
    });
    this.cutoutImage = null;

  }
  isOutOfViewport(elem) {
    // Get element's bounding
    var bounding = elem.getBoundingClientRect()

    // Check if it's out of the viewport on each side
    var out = {}
    out.top = bounding.top < 0
    out.left = bounding.left < 0
    out.bottom =
      bounding.bottom >
      (window.innerHeight || document.documentElement.clientHeight)
    out.right =
      bounding.right > (window.innerWidth || document.documentElement.clientWidth)
    out.any = out.top || out.left || out.bottom || out.right
    out.all = out.top && out.left && out.bottom && out.right

    return out
  }

  setCompleted() {
    this.querySelector(".product-wimmelbuch__config--button").style.display = "none";
    this.querySelector("#stickATCWrapper").style.display = "block";
  }
}

if (!customElements.get('wimmelbuch-stick-atc')) {
  customElements.define('wimmelbuch-stick-atc', WimmelbuchStickAtc);
}

// Lightweight 12-step Trainingbook configurator
class TrainingbookConfigDialog extends HTMLElement {
  constructor() {
    super();
    this.showDialog = false;
    this.step = 1;
    this.totalSteps = 12;
    this.buttonNext = this.querySelector('.product-wimmelbuch__config--dialog__button__next');
    this.buttonBack = this.querySelector('.product-wimmelbuch__config--dialog__button__back');
    this.stepText = this.querySelector('.product-wimmelbuch__config--dialog__heading-step-text');
    this.steps = [];
    for (let i = 1; i <= this.totalSteps; i++) {
      const el = this.querySelector(`#product-wimmelbuch__config--dialog__step-${i}`);
      if (el) this.steps[i] = el;
    }
    
    // Initialize selection Sets for steps 8, 9, and 10
    this.selectedGoals = new Set();
    this.selectedStresses = new Set();
    this.selectedTopics = new Set();
    
    // Initialize GA4 tracking data
    this.ga4TrackingData = {
      startTime: Date.now(),
      stepData: {},
      completedSteps: new Set()
    };
    
    // Debug and fix button event listeners
    
    // If buttons not found, try alternative selectors
    if (!this.buttonNext) {
      this.buttonNext = this.querySelector('[class*="button__next"]') || this.querySelector('button[class*="next"]');
    }
    if (!this.buttonBack) {
      this.buttonBack = this.querySelector('[class*="button__back"]') || this.querySelector('button[class*="back"]');
    }
    
    if (this.buttonNext) {
      this.buttonNext.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        this.nextStep();
      });
    }
    if (this.buttonBack) {
      this.buttonBack.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        this.previousStep();
      });
    }
    this.ensureUI();

    // DEBUG: Add global click listener to see what's being clicked
    document.addEventListener('click', (e) => {
      if (this.contains(e.target)) {
        
        // Check if it's a checkbox item
        if (e.target.classList.contains('trainingbook-step-8__goal-item') || 
            e.target.classList.contains('trainingbook-step-9__stress-item') || 
            e.target.classList.contains('trainingbook-step-10__topic-item')) {
        }
      }
    }, true);

    // Hide all steps except 1 by default so only one is visible per screen
    this.steps.forEach((el, idx) => {
      if (!el) return;
      el.style.display = idx === 1 ? 'block' : 'none';
    });

    // Populate breed dropdown from wimmelBuchConfig database
    this.populateBreedDropdown();
    
    // Live validation hooks
    const nameInput = this.querySelector('#trainingbook_input_name');
    const breedSelect = this.querySelector('#trainingbook_breed_select');
    if (nameInput) {
      nameInput.addEventListener('input', () => {
        this.updateNextEnabled();
        this.updateCharacterCounter();
        // Track name input changes
        this.trackStepAnswer(1, 'dog_name', nameInput.value);
      });
      // Initialize character counter
      this.updateCharacterCounter();
    }
    if (breedSelect) breedSelect.addEventListener('change', () => {
      this.updateNextEnabled();
      // Track breed selection
      this.trackStepAnswer(1, 'dog_breed', breedSelect.value);
    });
    
    // Photo upload functionality
    this.setupPhotoUpload();
    
    // Add validation event listeners for all steps
    this.setupValidationEventListeners();
    
    // Track configurator start
    this.trackConfiguratorStart();
  }

  // GA4 Tracking Methods
  trackConfiguratorStart() {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'event': 'trainingsbuch_configurator_start',
      'configurator_type': 'trainingsbuch',
      'total_steps': this.totalSteps,
      'timestamp': Date.now()
    });
  }

  trackStepProgression(fromStep, toStep, stepData = {}) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'event': 'trainingsbuch_step_progression',
      'from_step': fromStep,
      'to_step': toStep,
      'direction': fromStep < toStep ? 'forward' : 'backward',
      'step_data': stepData,
      'timestamp': Date.now()
    });
  }

  trackStepAnswer(step, question, answer) {
    // Store answer in tracking data
    if (!this.ga4TrackingData.stepData[step]) {
      this.ga4TrackingData.stepData[step] = {};
    }
    this.ga4TrackingData.stepData[step][question] = answer;

    // Send GA4 event for answer
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'event': 'trainingsbuch_step_answer',
      'step': step,
      'question': question,
      'answer': answer,
      'timestamp': Date.now()
    });
  }

  trackStepCompletion(step, stepData = {}) {
    this.ga4TrackingData.completedSteps.add(step);
    
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'event': 'trainingsbuch_step_completion',
      'step': step,
      'step_data': stepData,
      'completed_steps_count': this.ga4TrackingData.completedSteps.size,
      'timestamp': Date.now()
    });
  }

  trackConfiguratorCompletion() {
    const totalTime = Date.now() - this.ga4TrackingData.startTime;
    const completionRate = (this.ga4TrackingData.completedSteps.size / this.totalSteps) * 100;
    
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'event': 'trainingsbuch_configurator_completion',
      'total_time_ms': totalTime,
      'total_time_seconds': Math.round(totalTime / 1000),
      'completion_rate_percent': Math.round(completionRate),
      'completed_steps': Array.from(this.ga4TrackingData.completedSteps),
      'all_step_data': this.ga4TrackingData.stepData,
      'timestamp': Date.now()
    });
  }

  collectStepData(step) {
    const stepData = {};
    
    switch(step) {
      case 1:
        // Dog name and breed
        const nameInput = this.querySelector('#trainingbook_input_name');
        const breedSelect = this.querySelector('#trainingbook_breed_select');
        if (nameInput) stepData.dog_name = nameInput.value;
        if (breedSelect) stepData.dog_breed = breedSelect.value;
        break;
        
      case 2:
        // Photo upload
        const hasPhoto = this.hasCutoutImage();
        stepData.photo_uploaded = hasPhoto;
        if (hasPhoto) {
          stepData.photo_processing_successful = true;
        }
        break;
        
      case 3:
        // Processing step - no user input
        stepData.processing_completed = true;
        break;
        
      case 4:
        // Cover color selection and positioning
        if (this.selectedColor) stepData.cover_color = this.selectedColor;
        // Capture SVG state if available
        const capturedState = this.captureFinalSVGState();
        if (capturedState) {
          stepData.dog_position = capturedState.dogTransform;
          stepData.color_selected = capturedState.selectedColor;
        }
        break;
        
      case 5:
        // Gender selection
        const genderInput = this.querySelector('[name="tb_gender"]:checked');
        if (genderInput) stepData.gender = genderInput.value;
        break;
        
      case 6:
        // House training status
        const houseInput = this.querySelector('[name="tb_house"]:checked');
        if (houseInput) stepData.house_trained = houseInput.value;
        break;
        
      case 7:
        // Age selection
        const ageInput = this.querySelector('[name="tb_age"]:checked');
        if (ageInput) stepData.age = ageInput.value;
        break;
        
      case 8:
        // Training goals (multiple selection)
        const goals = Array.from(this.querySelectorAll('[name="tb_goals"]:checked')).map(x => x.value);
        stepData.training_goals = goals;
        stepData.goals_count = goals.length;
        break;
        
      case 9:
        // Stress factors (multiple selection)
        const stress = Array.from(this.querySelectorAll('[name="tb_stress"]:checked')).map(x => x.value);
        stepData.stress_factors = stress;
        stepData.stress_count = stress.length;
        break;
        
      case 10:
        // Training topics (multiple selection)
        const topics = Array.from(this.querySelectorAll('[name="tb_topics"]:checked')).map(x => x.value);
        stepData.training_topics = topics;
        stepData.topics_count = topics.length;
        break;
        
      case 11:
        // Training time and basic commands
        const timeInput = this.querySelector('[name="tb_time"]:checked');
        const basicInput = this.querySelector('[name="tb_basic"]:checked');
        if (timeInput) stepData.training_time = timeInput.value;
        if (basicInput) stepData.basic_commands = basicInput.value;
        break;
        
      case 12:
        // Final review - collect all data
        stepData.final_review = true;
        stepData.all_answers = this.ga4TrackingData.stepData;
        break;
    }
    
    return stepData;
  }

  populateBreedDropdown() {
    const breedSelect = this.querySelector('#trainingbook_breed_select');
    if (!breedSelect) {
      console.warn('TrainingbookConfigDialog: Breed select not found');
      return;
    }

    // Clear existing options except the first "Bitte auswählen"
    while (breedSelect.children.length > 1) {
      breedSelect.removeChild(breedSelect.lastChild);
    }

    // Hardcoded breeds for Trainingsbuch
    const hardcodedBreeds = [
      'Mischling', 'Australian Shepherd', 'Shiba Inu', 'Schäferhund', 'Cavalier King Charles',
      'Berner Sennenhund', 'Golden Retriever', 'Deutsch Kurzhaar', 'Dackel', 'Deutsche Dogge', 'Mops',
      'Border Collie', 'Akita', 'Malinois', 'Havaneser', 'Neufundländer', 'Labrador Retriever', 'Deutsch Langhaar',
      'Rauhaardackel', 'Franz. Bulldog', 'Pekinese', 'Collie', 'Basenji', 'Rottweiler', 'Malteser',
      'Bernhardiner', 'Flat Coated Retriever', 'Whippet', 'Langhaardackel', 'Englische Bulldogge', 'Zwergspitz',
      'Collie Kurzhaar', 'Chow Chow', 'Dobermann', 'Bolonka Zwetna', 'Husky',
      'Viszla', 'Foxterrier', 'Old Englische Bulldogge', 'Corgi', 'Bearded Collie', 'Shar Pei', 'Boxer',
      'Shih Tzu', 'Goldendoodle', 'Kleiner Münsterländer', 'Border Terrier', 'Aust. Cattle Dog', 'Podenco',
      'Bull Terrier', 'Tibet Terrier', 'Labradoodle', 'Irish Red Setter', 'Airedale Terrier', 'Mudi',
      'Xoloitzcuintle', 'American Staff. Terrier', 'Bichon Frisé', 'Irish Setter', 'Cairn Terrier',
      'Bobtail', 'Afgh. Windhund', 'Staff. Bullterrier', 'Yorkshire Terrier', 'Engl. Springer Spaniel',
      'Rhodesian Ridgeback', 'Appenzeller Sennenhund', 'Greyhound', 'Pitbull Terrier', 'Westhighland Terrier',
      'Breton Epagneul', 'Entlebucher Sennenhund', 'Samoyede', 'Bouvier des Flandres', 'Chihuahua', 'Stabyhoun',
      'Dt. Jagdterrier', 'Shetland Sheepdog', 'Wetterhoun', 'Hovawart', 'Mini Australian Shepherd',
      'Cane Corso', 'Boston Terrier', 'English Pointer', 'Jack Russel Terrier', 'Riesenschnauzer', 'Gordon Setter',
      'Weimaraner', 'Leonberger', 'Deutscher Wachtelhund', 'Deutsch Drahthaar', 'Mastiff', 'Cocker Spaniel',
      'Parson R. Terrier', 'Dogo Argentino', 'Beagle', 'Pudel', 'Elo', 'Dalmatiner', 'Eurasier', 'Kooikerhondje'
    ];

    // Sort breeds alphabetically in German
    const sortedBreeds = hardcodedBreeds.sort((a, b) => a.localeCompare(b, 'de'));

    // Add breed options to dropdown
    sortedBreeds.forEach(breed => {
      const option = document.createElement('option');
      option.value = breed;
      option.textContent = breed;
      breedSelect.appendChild(option);
    });

  }

  setupPhotoUpload() {
    const fileInput = this.querySelector('#trainingbook_photo_upload');
    const uploadArea = this.querySelector('#trainingbook_upload_area');
    if (!fileInput) return;

    // File input change event
    fileInput.addEventListener('change', (event) => {
      const file = event.target.files[0];
      if (file) {
        this.handleFileUpload(file);
      }
    });

    // Drag and drop functionality
    if (uploadArea) {
      uploadArea.addEventListener('dragover', (e) => {
        e.preventDefault();
        e.stopPropagation();
        uploadArea.classList.add('dragover');
      });

      uploadArea.addEventListener('dragleave', (e) => {
        e.preventDefault();
        e.stopPropagation();
        uploadArea.classList.remove('dragover');
      });

      uploadArea.addEventListener('drop', (e) => {
        e.preventDefault();
        e.stopPropagation();
        uploadArea.classList.remove('dragover');
        
        const files = e.dataTransfer.files;
        if (files.length > 0) {
          this.handleFileUpload(files[0]);
        }
      });
    }
  }

  handleFileUpload(file) {
    // Validate file type
    if (!file.type.match(/^image\/(jpeg|jpg|png)$/)) {
      alert('Bitte wähle eine JPEG oder PNG Datei aus.');
      return;
    }

    // Validate file size (20MB limit)
    if (file.size > 20 * 1024 * 1024) {
      alert('Die Datei ist zu groß. Bitte wähle eine Datei unter 20 MB.');
      return;
    }

    // Track photo upload
    this.trackStepAnswer(2, 'photo_uploaded', 'true');
    this.trackStepAnswer(2, 'photo_file_size', Math.round(file.size / 1024) + 'KB');
    this.trackStepAnswer(2, 'photo_file_type', file.type);

    // Display the image
    this.displayUploadedImage(file);
    
    // Update validation for step 2
    this.updateNextEnabled();
  }

  displayUploadedImage(file) {
    const reader = new FileReader();
    const imagePreview = this.querySelector('#trainingbook_image_preview');
    const previewImg = this.querySelector('#trainingbook_preview_img');
    const uploadArea = this.querySelector('#trainingbook_upload_area');
    const loadingHint = this.querySelector('#trainingbook_loading_hint');

    reader.onload = (e) => {
      if (previewImg && imagePreview && uploadArea) {
        // Set the image source
        previewImg.src = e.target.result;
        previewImg.style.width = '200px';
        previewImg.style.height = '200px';
        previewImg.style.objectFit = 'contain';
        
        // Show the preview and hide the upload area
        imagePreview.style.display = 'flex';
        uploadArea.style.display = 'none';
        
        // Show loading hint for image processing
        if (loadingHint) {
          loadingHint.style.display = 'flex';
        }
        
        
        // Start background removal process
        this.processBackgroundRemoval(file);
      }
    };

    reader.readAsDataURL(file);
  }

  async processBackgroundRemoval(file) {
    
    const facePreview = this.querySelector('#trainingbook_face_preview');
    const processing = this.querySelector('#trainingbook_processing');
    const faceImg = this.querySelector('#trainingbook_face_img');
    
    
    if (!facePreview || !processing || !faceImg) {
      console.error('TrainingbookConfigDialog: Face detection elements not found');
      console.error('TrainingbookConfigDialog: facePreview:', facePreview);
      console.error('TrainingbookConfigDialog: processing:', processing);
      console.error('TrainingbookConfigDialog: faceImg:', faceImg);
      return;
    }
    

    
    // Disable the "Cover erstellen" button during processing
    const coverErstellenButton = this.querySelector('.step-nav-btn--next');
    if (coverErstellenButton) {
      coverErstellenButton.disabled = true;
      coverErstellenButton.style.opacity = '0.5';
      coverErstellenButton.style.cursor = 'not-allowed';
    }
    
    // Show the face preview area and processing indicator
    
    if (facePreview) {
      facePreview.style.display = 'flex';
    } else {
      console.error('TrainingbookConfigDialog: Face preview element not found!');
    }
    
    if (processing) {
      processing.style.display = 'flex';
    } else {
      console.error('TrainingbookConfigDialog: Processing element not found!');
    }
    
    if (faceImg) {
      faceImg.style.display = 'none';
    } else {
      console.error('TrainingbookConfigDialog: Face image element not found!');
    }
    
    try {
      // Create FormData to send the image
      const formData = new FormData();
      formData.append('image', file);
      
      // Convert file to base64
      const base64Image = await this.fileToBase64(file);
      
      // Call AWS Lambda function via API Gateway
      const response = await fetch('https://petprinted-traningsbuch-api-a82da453408d.herokuapp.com/api/remove-background', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          imageBase64: base64Image,
          fileName: file.name
        })
      });
      
      
      if (!response.ok) {
        const errorText = await response.text();
        console.error('TrainingbookConfigDialog: API Error response:', errorText);
        throw new Error(`Face detection failed: ${response.status} - ${errorText}`);
      }
      
      const apiGatewayResponse = await response.json();
      
      // Parse the actual result from the API Gateway body
      let result;
      if (apiGatewayResponse.statusCode && apiGatewayResponse.body) {
        // API Gateway format: { statusCode, headers, body }
        result = JSON.parse(apiGatewayResponse.body);
      } else {
        // Direct format: { success, originalImageUrl, faceImageUrl }
        result = apiGatewayResponse;
      }
      
      if (result.success && result.processedImageUrl) {
        // Store the cutout image URLs for cover construction
        this.originalImageUrl = result.originalImageUrl;
        this.processedImageUrl = result.processedImageUrl;
        
        // Hide processing indicator and show the processed image (background removed)
        processing.style.display = 'none';
        
        // Clear any previous error messages
        processing.innerHTML = '';
        
        faceImg.src = result.processedImageUrl;
        faceImg.style.display = 'block';
        faceImg.style.width = '200px';
        faceImg.style.height = '200px';
        faceImg.style.objectFit = 'contain';
        
        // Hide loading hint from original image
        
        const loadingHint = this.querySelector('#trainingbook_loading_hint');
        if (loadingHint) {
          loadingHint.style.display = 'none';
        }
        
        // Re-enable the "Cover erstellen" button after successful processing
        if (coverErstellenButton) {
          coverErstellenButton.disabled = false;
          coverErstellenButton.style.opacity = '1';
          coverErstellenButton.style.cursor = 'pointer';
        }
        
        // Update validation for step 2
        this.updateNextEnabled();
        
        
        // Track successful background removal
        this.trackStepAnswer(2, 'background_removal_successful', 'true');
        this.trackStepAnswer(3, 'processing_completed', 'true');
      } else {
        console.error('TrainingbookConfigDialog: API returned error:', result);
        throw new Error(result.error || 'Background removal failed');
      }
      
    } catch (error) {
      console.error('TrainingbookConfigDialog: Background removal error:', error);
      
      // Hide loading hint from original image
      
      const loadingHint = this.querySelector('#trainingbook_loading_hint');
      if (loadingHint) {
        loadingHint.style.display = 'none';
      }
      
      // Keep the "Cover erstellen" button disabled when face recognition fails
      if (coverErstellenButton) {
        coverErstellenButton.disabled = true;
        coverErstellenButton.style.opacity = '0.5';
        coverErstellenButton.style.cursor = 'not-allowed';
      }
      
      // Update validation for step 2
      this.updateNextEnabled();
      
      // Show error message to user
      processing.innerHTML = '<p style="color: #ff0000; text-align: center;">Fehler bei der Gesichtserkennung. Bitte versuche es erneut.</p>';
    }
  }

  fileToBase64(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = error => reject(error);
    });
  }

  // Method to get the cutout image URLs for cover construction
  getCutoutImageUrls() {
    return {
      originalImageUrl: this.originalImageUrl || null,
      processedImageUrl: this.processedImageUrl || null,
      hasCutoutImage: !!(this.originalImageUrl && this.processedImageUrl)
    };
  }

  // Method to check if cutout image is available
  hasCutoutImage() {
    return !!(this.originalImageUrl && this.processedImageUrl);
  }

  // Trainingbook cover SVG template using metaobject images (malbuch-style) - WITH FRAME for step 4
  getCoverSVGTemplate() {
    return `
      <svg viewBox="0 0 400 600" xmlns="http://www.w3.org/2000/svg" class="trainingbook-cover-svg">
        <!-- Background cover image from metaobject -->
        <g class="trainingbook-layer-image">
          <image href="" x="0" y="0" width="100%" height="100%" preserveAspectRatio="none"/>
        </g>
        
        <!-- Dog cutout image from step 2 - draggable (behind static images) -->
        <g class="trainingbook-dog-cutout" id="draggable-dog-group" style="cursor: move;">
          <!-- Simple visible frame around the dog image -->
          <rect x="-100" y="200" width="600" height="600" 
                fill="none" stroke="#000000" stroke-width="5" stroke-dasharray="8,8" 
                opacity="0.9"/>
          <image id="dog-cutout-image" href="" x="-100" y="200" width="600" height="600" preserveAspectRatio="xMidYMid meet"/>
        </g>
        
        <!-- Static Additional Images (Non-draggable) - IN FRONT of dog cutout -->
        <g class="trainingbook-static-images">
          <!-- Logo (centered in middle area) -->
          <image id="static-logo" x="280" y="550" width="100" height="50" preserveAspectRatio="xMidYMid meet" href="https://petprinted-trainingsbuch.s3.amazonaws.com/cover/logo.png"/>
          
          <!-- Bottom Text (centered lower area) -->
          <image id="static-bottom-text" x="30" y="450" width="350" height="100" preserveAspectRatio="xMidYMid meet" href="https://petprinted-trainingsbuch.s3.amazonaws.com/cover/bottom_text.png"/>
          
          <!-- Paw (centered middle-right area) -->
          <image id="static-paw" x="260" y="300" width="150" height="150" preserveAspectRatio="xMidYMid meet" href="https://petprinted-trainingsbuch.s3.amazonaws.com/cover/paw.png"/>
        </g>
        
        <!-- Text overlay (personalized dog name) - moved higher with vertical stretch -->
        <g class="trainingbook-overlay--text">
          <text x="200" y="160" text-anchor="middle" font-family="AksharBold, 'Akshar', 'Arial Black', Arial, sans-serif" font-size="39" font-weight="bold" fill="#FBF6A7" letter-spacing="8px" transform="scale(1.5, 2.2)" transform-origin="200 130">
            <tspan id="dog-name-display">HUNDENAME</tspan>
          </text>
        </g>
      </svg>
    `;
  }

  // Trainingbook cover SVG template for final preview (step 12) - WITHOUT FRAME
  getFinalCoverSVGTemplate() {
    return `
      <svg viewBox="0 0 400 600" xmlns="http://www.w3.org/2000/svg" class="trainingbook-cover-svg">
        <!-- Background cover image from metaobject -->
        <g class="trainingbook-layer-image">
          <image href="" x="0" y="0" width="100%" height="100%" preserveAspectRatio="none"/>
        </g>
        
        <!-- Dog cutout image from step 2 - draggable (behind static images) -->
        <g class="trainingbook-dog-cutout" id="draggable-dog-group" style="cursor: move;">
          <image id="dog-cutout-image" href="" x="-100" y="200" width="600" height="600" preserveAspectRatio="xMidYMid meet"/>
        </g>
        
        <!-- Static Additional Images (Non-draggable) - IN FRONT of dog cutout -->
        <g class="trainingbook-static-images">
          <!-- Logo (centered in middle area) -->
          <image id="static-logo" x="280" y="550" width="100" height="50" preserveAspectRatio="xMidYMid meet" href="https://petprinted-trainingsbuch.s3.amazonaws.com/cover/logo.png"/>
          
          <!-- Bottom Text (centered lower area) -->
          <image id="static-bottom-text" x="30" y="450" width="350" height="100" preserveAspectRatio="xMidYMid meet" href="https://petprinted-trainingsbuch.s3.amazonaws.com/cover/bottom_text.png"/>
          
          <!-- Paw (centered middle-right area) -->
          <image id="static-paw" x="260" y="300" width="150" height="150" preserveAspectRatio="xMidYMid meet" href="https://petprinted-trainingsbuch.s3.amazonaws.com/cover/paw.png"/>
        </g>
        
        <!-- Text overlay (personalized dog name) - moved higher with vertical stretch -->
        <g class="trainingbook-overlay--text">
          <text x="200" y="160" text-anchor="middle" font-family="AksharBold, 'Akshar', 'Arial Black', Arial, sans-serif" font-size="39" font-weight="bold" fill="#FBF6A7" letter-spacing="8px" transform="scale(1.5, 2.2)" transform-origin="200 130">
            <tspan id="dog-name-display">HUNDENAME</tspan>
          </text>
        </g>
      </svg>
    `;
  }

  // Get cover data from S3 or config
  getTrainingbookCovers() {
    return window.trainingbookCovers || [];
  }

  // Optional: Dynamic S3 cover URL generation
  generateS3CoverUrl(colorHandle, bucketName = 'petprinted-trainingsbuch') {
    return `https://${bucketName}.s3.amazonaws.com/cover/trainingbook-cover-${colorHandle}.png`;
  }

  // Update cover preview with selected color using metaobject images (malbuch-style)
  updateCoverPreview(selectedColor) {
    
    // Find or create the cover container
    let coverContainer = this.querySelector('#trainingbook_cover_preview_container');
    if (!coverContainer) {
      // Replace the img with a div container for SVG
      const oldImg = this.querySelector('#trainingbook_cover_preview');
      if (oldImg) {
        coverContainer = document.createElement('div');
        coverContainer.id = 'trainingbook_cover_preview_container';
        coverContainer.className = 'trainingbook-step-4__cover-image';
        oldImg.parentNode.replaceChild(coverContainer, oldImg);
      } else {
        console.error('TrainingbookConfigDialog: Cover preview element not found');
        return;
      }
    }
    
    // Get cover data from metaobjects
    const covers = this.getTrainingbookCovers();
    const selectedCover = covers.find(cover => cover.color_handle === selectedColor);
    
    if (!selectedCover) {
      console.error('TrainingbookConfigDialog: No cover found for color:', selectedColor);
      return;
    }
    
    // Update the SVG content if not already present
    if (!coverContainer.querySelector('svg')) {
      // Use appropriate template based on current step
      let svgTemplate;
      if (this.step === 4) {
        // Step 4: Use template WITH frame for interaction
        svgTemplate = this.getCoverSVGTemplate();
      } else {
        // Step 12 or other steps: Use template WITHOUT frame for final preview
        svgTemplate = this.getFinalCoverSVGTemplate();
      }
      coverContainer.innerHTML = svgTemplate;
    } else {
      // Force recreation of SVG when switching to step 12 to remove frame
      if (this.step === 12) {
        const svgTemplate = this.getFinalCoverSVGTemplate();
        coverContainer.innerHTML = svgTemplate;
      }
    }
    
    // Update the background image (malbuch-style)
    const imageElement = coverContainer.querySelector('.trainingbook-layer-image image');
    if (imageElement) {
      imageElement.setAttribute('href', selectedCover.cover_image);
    }
    
    // Add the dog cutout image from step 2
    const dogCutoutElement = coverContainer.querySelector('#dog-cutout-image');
    if (dogCutoutElement && this.processedImageUrl) {
      dogCutoutElement.setAttribute('href', this.processedImageUrl);
      
      // Initialize drag functionality
      this.initializeDragFunctionality(coverContainer);
    } else if (dogCutoutElement) {
      // Hide cutout if no image available
      dogCutoutElement.style.display = 'none';
    }
    
    // Update dog name in the SVG text overlay
    const dogNameInput = this.querySelector('#trainingbook_input_name');
    const dogName = dogNameInput?.value?.trim();
    const dogNameDisplay = coverContainer.querySelector('#dog-name-display');
    
    if (dogNameDisplay) {
      let displayName;
      if (dogName && dogName.length > 0) {
        // Use actual dog name if provided
        displayName = dogName.toUpperCase();
        dogNameDisplay.textContent = displayName;
      } else {
        // Show "HUNDENAME" as placeholder if no name entered
        displayName = 'HUNDENAME';
        dogNameDisplay.textContent = displayName;
      }
      
      // Apply dynamic scaling based on name length
      this.updateNameScaling(coverContainer, displayName.length);
    }
    
  }

  // Calculate and apply dynamic scaling for dog name based on character length
  updateNameScaling(coverContainer, nameLength) {
    // Find the text element that contains the dog name
    const textElement = coverContainer.querySelector('.trainingbook-overlay--text text');
    if (!textElement) return;
    
    // Calculate horizontal scale based on character length
    // Based on user examples:
    // 3 chars (JOE): 2.0
    // 6 chars (Bronny): 1.5  
    // 8 chars (HUNDENAME): 1.35
    // 12 chars (DDDDDDDDDDDD): 1.0
    
    let horizontalScale;
    if (nameLength <= 3) {
      horizontalScale = 2.0;
    } else if (nameLength <= 6) {
      // Linear interpolation between 2.0 (3 chars) and 1.5 (6 chars)
      horizontalScale = 2.0 - ((nameLength - 3) * 0.5 / 3);
    } else if (nameLength <= 8) {
      // Linear interpolation between 1.5 (6 chars) and 1.35 (8 chars)
      horizontalScale = 1.5 - ((nameLength - 6) * 0.15 / 2);
    } else if (nameLength <= 12) {
      // Linear interpolation between 1.35 (8 chars) and 1.0 (12 chars)
      horizontalScale = 1.35 - ((nameLength - 8) * 0.35 / 4);
    } else {
      // For names longer than 12 characters, use minimum scale
      horizontalScale = 1.0;
    }
    
    // Keep vertical scale constant at 2.2 as specified
    const verticalScale = 2.2;
    
    // Apply the new transform
    textElement.setAttribute('transform', `scale(${horizontalScale}, ${verticalScale})`);
    
  }

  // Initialize drag and scale functionality for the dog cutout
  initializeDragFunctionality(coverContainer) {
    const draggableGroup = coverContainer.querySelector('#draggable-dog-group');
    if (!draggableGroup) return;

    let isDragging = false;
    let isPinching = false;
    let startX, startY;
    let currentTransform = { x: 0, y: 0, scale: 1 };
    let initialDistance = 0;
    let initialScale = 1;

    // Store original position for reset functionality
    this.originalDogTransform = { x: 0, y: 0, scale: 1 };
    this.currentDogTransform = currentTransform;

    // Parse existing transform if any
    const existingTransform = draggableGroup.getAttribute('transform');
    if (existingTransform) {
      const translateMatch = existingTransform.match(/translate\(([^,]+),([^)]+)\)/);
      const scaleMatch = existingTransform.match(/scale\(([^)]+)\)/);
      
      if (translateMatch) {
        currentTransform.x = parseFloat(translateMatch[1]);
        currentTransform.y = parseFloat(translateMatch[2]);
      }
      if (scaleMatch) {
        currentTransform.scale = parseFloat(scaleMatch[1]);
      }
    }

    // Helper function to update transform
    const updateTransform = () => {
      const transform = `translate(${currentTransform.x}, ${currentTransform.y}) scale(${currentTransform.scale})`;
      draggableGroup.setAttribute('transform', transform);
      
      // Update stored current transform
      this.currentDogTransform = { ...currentTransform };
      // Log current position and zoom level on every update (move or zoom)
    };

    // Helper function to constrain scale within boundaries
    const constrainScale = (scale) => {
      const minScale = 0.3; // Minimum 30% of original size
      const maxScale = 3.0; // Maximum 300% of original size
      return Math.max(minScale, Math.min(maxScale, scale));
    };

    // Helper function to constrain position within boundaries
    const constrainPosition = (x, y, scale) => {
      // Get the SVG container dimensions
      const svgElement = coverContainer.querySelector('svg');
      if (!svgElement) return { x, y };
      
      const svgRect = svgElement.getBoundingClientRect();
      const viewBox = svgElement.getAttribute('viewBox');
      const [viewBoxX, viewBoxY, viewBoxWidth, viewBoxHeight] = viewBox ? viewBox.split(' ').map(Number) : [0, 0, 400, 600];
      
      // Calculate the scaled image dimensions (approximate)
      const imageWidth = 600 * scale; // Original image width * scale
      const imageHeight = 600 * scale; // Original image height * scale
      
      // Calculate boundaries (keep image within viewBox)
      const maxX = viewBoxWidth - imageWidth * 0.5; // Allow half image to go outside
      const minX = -imageWidth * 0.5;
      const maxY = viewBoxHeight - imageHeight * 0.5;
      const minY = -imageHeight * 0.5;
      
      // Constrain position
      const constrainedX = Math.max(minX, Math.min(maxX, x));
      const constrainedY = Math.max(minY, Math.min(maxY, y));
      
      return { x: constrainedX, y: constrainedY };
    };

    // Helper function to calculate distance between two touch points
    const getDistance = (touch1, touch2) => {
      const dx = touch1.clientX - touch2.clientX;
      const dy = touch1.clientY - touch2.clientY;
      return Math.sqrt(dx * dx + dy * dy);
    };

    // Helper function to calculate center point between two touches
    const getCenter = (touch1, touch2) => {
      return {
        x: (touch1.clientX + touch2.clientX) / 2,
        y: (touch1.clientY + touch2.clientY) / 2
      };
    };

    // Mouse events for dragging
    draggableGroup.addEventListener('mousedown', (e) => {
      isDragging = true;
      startX = e.clientX;
      startY = e.clientY;
      draggableGroup.style.cursor = 'grabbing';
      e.preventDefault();
      e.stopPropagation();
    });

    document.addEventListener('mousemove', (e) => {
      if (isDragging) {
        const deltaY = e.clientY - startY;
        
        // Only allow vertical movement (y-direction), keep x at original position
        const newX = this.originalDogTransform.x || 0; // Keep x at original position
        const newY = currentTransform.y + deltaY;
        
        // Apply boundary constraints
        const constrained = constrainPosition(newX, newY, currentTransform.scale);
        currentTransform.x = constrained.x;
        currentTransform.y = constrained.y;
        
        // Update start position for next frame to prevent accumulation
        startX = e.clientX;
        startY = e.clientY;
        
        updateTransform();
        e.preventDefault();
        e.stopPropagation();
      }
    });

    document.addEventListener('mouseup', () => {
      if (isDragging) {
        isDragging = false;
        draggableGroup.style.cursor = 'move';
      }
    });

    // Mouse wheel zoom functionality - DISABLED
    // draggableGroup.addEventListener('wheel', (e) => {
    //   e.preventDefault();
    //   e.stopPropagation();
    //   e.stopImmediatePropagation();
    //   
    //   const delta = e.deltaY > 0 ? 0.99 : 1.01; // Zoom out or in (reduced speed)
    //   const newScale = constrainScale(currentTransform.scale * delta);
    //   
    //   currentTransform.scale = newScale;
    //   updateTransform();
    //   
    // }, true);

    // Touch events for mobile
    draggableGroup.addEventListener('touchstart', (e) => {
      e.preventDefault();
      e.stopPropagation();
      
      if (e.touches.length === 1) {
        // Single touch - dragging
        const touch = e.touches[0];
        isDragging = true;
        isPinching = false;
        startX = touch.clientX;
        startY = touch.clientY;
      } else if (e.touches.length === 2) {
        // Two touches - pinching DISABLED (zoom disabled)
        // isDragging = false;
        // isPinching = true;
        // initialDistance = getDistance(e.touches[0], e.touches[1]);
        // initialScale = currentTransform.scale;
        // Ignore pinch gestures - only allow single touch dragging
      }
    });

    document.addEventListener('touchmove', (e) => {
      e.preventDefault();
      e.stopPropagation();
      
      if (isDragging && e.touches.length === 1) {
        // Single touch dragging - only vertical movement
        const touch = e.touches[0];
        const deltaY = touch.clientY - startY;
        
        // Only allow vertical movement (y-direction), keep x at original position
        const newX = this.originalDogTransform.x || 0; // Keep x at original position
        const newY = currentTransform.y + deltaY;
        
        // Apply boundary constraints
        const constrained = constrainPosition(newX, newY, currentTransform.scale);
        currentTransform.x = constrained.x;
        currentTransform.y = constrained.y;
        
        // Update start position for next frame to prevent accumulation
        startX = touch.clientX;
        startY = touch.clientY;
        
        updateTransform();
      } else if (isPinching && e.touches.length === 2) {
        // Two touch pinching - DISABLED (zoom disabled)
        // const currentDistance = getDistance(e.touches[0], e.touches[1]);
        // const scaleFactor = currentDistance / initialDistance;
        // const newScale = constrainScale(initialScale * scaleFactor);
        // 
        // currentTransform.scale = newScale;
        // updateTransform();
        // 
      }
    });

    // Combined touchend handler for both dragging and double-tap
    let lastTap = 0;
    
    document.addEventListener('touchend', (e) => {
      if (isDragging) {
        isDragging = false;
      }
      if (isPinching) {
        isPinching = false;
      }
    });

    draggableGroup.addEventListener('touchend', (e) => {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      
      const currentTime = new Date().getTime();
      const tapLength = currentTime - lastTap;
      if (tapLength < 500 && tapLength > 0) {
        // Double tap detected - reset to original position and scale
        currentTransform.x = 0;
        currentTransform.y = 0;
        //currentTransform.scale = 1;
        updateTransform();
      }
      lastTap = currentTime;
    }, true);

  }

  // Reset dog position to original
  resetDogPosition() {
    const coverContainer = this.querySelector('#trainingbook_cover_preview_container');
    if (!coverContainer) return;

    const draggableGroup = coverContainer.querySelector('#draggable-dog-group');
    if (!draggableGroup) return;

    // Reset to original position and scale
    const originalTransform = this.originalDogTransform || { x: 0, y: 0, scale: 1 };
    const transform = `translate(${originalTransform.x}, ${originalTransform.y}) scale(${originalTransform.scale})`;
    draggableGroup.setAttribute('transform', transform);
    
    // Update stored current transform
    this.currentDogTransform = { ...originalTransform };
    
  }

  // CRITICAL: Capture the final state of the SVG viewer
  captureFinalSVGState() {
    
    const coverContainer = this.querySelector('#trainingbook_cover_preview_container');
    if (!coverContainer) {
      console.error('TrainingbookConfigDialog: CRITICAL - Cover container not found for state capture!');
      return null;
    }

    const svgElement = coverContainer.querySelector('svg');
    if (!svgElement) {
      console.error('TrainingbookConfigDialog: CRITICAL - SVG element not found for state capture!');
      return null;
    }

    // Get the current transform of the draggable dog
    const draggableDogGroup = svgElement.querySelector('#draggable-dog-group');
    const dogTransform = draggableDogGroup ? draggableDogGroup.getAttribute('transform') : '';

    // Get the current selected color
    const activeColorOption = this.querySelector('.trainingbook-step-4__color-option--active');
    const selectedColor = activeColorOption ? activeColorOption.getAttribute('data-color') : 'teal';

    // Get the dog name
    const dogNameInput = this.querySelector('#trainingbook_input_name');
    const dogName = dogNameInput?.value?.trim() || 'HUNDENAME';

    // Get the cover URL
    const covers = this.getTrainingbookCovers();
    const selectedCover = covers.find(cover => cover.color_handle === selectedColor);
    const coverImageUrl = selectedCover ? selectedCover.cover_image : '';

    // Create a clean SVG WITHOUT frame for final preview
    const cleanSVGTemplate = this.getFinalCoverSVGTemplate();
    const tempContainer = document.createElement('div');
    tempContainer.innerHTML = cleanSVGTemplate;
    const cleanSVGElement = tempContainer.querySelector('svg');
    
    // Apply the current transforms and data to the clean SVG
    if (cleanSVGElement) {
      // Set background image
      const imageElement = cleanSVGElement.querySelector('.trainingbook-layer-image image');
      if (imageElement) {
        imageElement.setAttribute('href', coverImageUrl);
      }
      
      // Set dog image and transform
      const dogCutoutElement = cleanSVGElement.querySelector('#dog-cutout-image');
      const cleanDraggableGroup = cleanSVGElement.querySelector('#draggable-dog-group');
      if (dogCutoutElement && this.processedImageUrl) {
        dogCutoutElement.setAttribute('href', this.processedImageUrl);
      }
      if (cleanDraggableGroup && dogTransform) {
        cleanDraggableGroup.setAttribute('transform', dogTransform);
      }
      
      // Set dog name
      const dogNameDisplay = cleanSVGElement.querySelector('#dog-name-display');
      if (dogNameDisplay) {
        dogNameDisplay.textContent = dogName.toUpperCase();
      }
      
      // Apply name scaling
      this.updateNameScaling(tempContainer, dogName.length);
    }

    // Capture the clean SVG as a string (final rendered state WITHOUT frame)
    const svgString = cleanSVGElement ? cleanSVGElement.outerHTML : svgElement.outerHTML;

    // Create the complete state object
    const finalSVGState = {
      timestamp: new Date().toISOString(),
      dogTransform: dogTransform,
      selectedColor: selectedColor,
      dogName: dogName,
      coverImageUrl: coverImageUrl,
      processedImageUrl: this.processedImageUrl,
      originalImageUrl: this.originalImageUrl,
      completeSVG: svgString,
      viewBox: svgElement.getAttribute('viewBox'),
      staticImages: {
        logo: 'https://petprinted-trainingsbuch.s3.amazonaws.com/cover/logo.png',
        bottomText: 'https://petprinted-trainingsbuch.s3.amazonaws.com/cover/bottom_text.png',
        paw: 'https://petprinted-trainingsbuch.s3.amazonaws.com/cover/paw.png'
      }
    };

    // Store the state in multiple places for redundancy
    this.finalSVGState = finalSVGState;
    window.trainingbookFinalState = finalSVGState;
    
    // Also store in localStorage as backup
    try {
      localStorage.setItem('trainingbook_final_svg_state', JSON.stringify(finalSVGState));
    } catch (e) {
      console.warn('TrainingbookConfigDialog: Could not save to localStorage:', e);
    }

    
    return finalSVGState;
  }

  // Get the captured SVG state
  getFinalSVGState() {
    return this.finalSVGState || window.trainingbookFinalState || null;
  }

  // Static method to retrieve the final SVG state from anywhere
  static getFinalTrainingbookState() {
    // Try to get from window first
    if (window.trainingbookFinalState) {
      return window.trainingbookFinalState;
    }
    
    // Try to get from localStorage as backup
    try {
      const stored = localStorage.getItem('trainingbook_final_svg_state');
      if (stored) {
        return JSON.parse(stored);
      }
    } catch (e) {
      console.warn('TrainingbookConfigDialog: Could not retrieve from localStorage:', e);
    }
    
    return null;
  }

  startProgressAnimation() {
    
    const progressFill = this.querySelector('#trainingbook_progress_fill');
    
    if (!progressFill) {
      console.error('TrainingbookConfigDialog: Progress fill element not found!');
      // Fallback - just advance after delay
      setTimeout(() => {
        if (this.buttonNext) this.buttonNext.disabled = false;
        this.showStep(4);
      }, 4000);
      return;
    }

    // Reset to 0 first and force styles
    progressFill.style.width = '0%';
    progressFill.style.background = 'linear-gradient(90deg, #ED931B 0%, #ffb347 100%)';
    progressFill.style.height = '100%';
    progressFill.style.display = 'block';
    

    let progress = 0;
    const duration = 4000; // 4 seconds total
    const interval = 50; // Update every 50ms
    const increment = (100 / (duration / interval));

    const progressInterval = setInterval(() => {
      progress += increment;
      const newWidth = `${Math.min(progress, 100)}%`;
      
      // Force all styles inline to override any CSS conflicts
      progressFill.style.setProperty('width', newWidth, 'important');
      progressFill.style.setProperty('background', 'linear-gradient(90deg, #ED931B 0%, #ffb347 100%)', 'important');
      progressFill.style.setProperty('height', '100%', 'important');
      progressFill.style.setProperty('display', 'block', 'important');
      

      if (progress >= 100) {
        clearInterval(progressInterval);
        
        // Wait a moment, then proceed to next step
        setTimeout(() => {
          // Re-enable the button
          if (this.buttonNext) this.buttonNext.disabled = false;
          // Auto-advance to step 4
          this.showStep(4);
        }, 500);
      }
    }, interval);

  }

  setupStep4() {
    
    // Update cover title with dog's name
    const dogName = this.querySelector('#trainingbook_input_name')?.value?.trim() || 'Polly';
    const coverTitle = this.querySelector('#trainingbook_cover_title');
    if (coverTitle) {
      coverTitle.textContent = `${dogName}'s`;
    }
    
    // Initialize the cover preview with default color (teal)
    this.updateCoverPreview('teal');
    
    // Setup color selection
    const colorOptions = this.querySelectorAll('.trainingbook-step-4__color-option');
    colorOptions.forEach(option => {
      option.addEventListener('click', (e) => {
        e.preventDefault();
        
        // Remove active class from all options
        colorOptions.forEach(opt => opt.classList.remove('trainingbook-step-4__color-option--active'));
        
        // Add active class to clicked option
        option.classList.add('trainingbook-step-4__color-option--active');
        
        const selectedColor = option.getAttribute('data-color');
        
        // Track color selection
        this.trackStepAnswer(4, 'cover_color', selectedColor);
        
        // Update the cover preview with the selected color
        this.updateCoverPreview(selectedColor);
      });
    });
    
    // Setup reset position button
    const resetButton = this.querySelector('#trainingbook_reset_position');
    if (resetButton) {
      // Store reference to this for the event handler
      const self = this;
      resetButton.addEventListener('click', function(e) {
        e.preventDefault();
        self.resetDogPosition();
      });
    }
    
  }

  setupStep5() {
    
    // Update questions with dog's name
    const dogName = this.querySelector('#trainingbook_input_name')?.value?.trim() || 'Polly';
    const dogNameSpans = this.querySelectorAll('#trainingbook_step5_dog_name, #trainingbook_step5_dog_name_2');
    dogNameSpans.forEach(span => {
      if (span) span.textContent = dogName;
    });
    
    // Setup gender selection
    const genderOptions = this.querySelectorAll('[data-gender]');
    genderOptions.forEach(option => {
      option.addEventListener('click', (e) => {
        e.preventDefault();
        
        // Remove active class from all gender options only
        genderOptions.forEach(opt => opt.classList.remove('trainingbook-step-5__option--active'));
        
        // Add active class to clicked option
        option.classList.add('trainingbook-step-5__option--active');
        
        const selectedGender = option.getAttribute('data-gender');
        
        // Track gender selection
        this.trackStepAnswer(5, 'gender', selectedGender);
      });
    });
    
    // Setup house-trained selection (separate from gender selection)
    const houseOptions = this.querySelectorAll('[data-housetrained]');
    houseOptions.forEach(option => {
      option.addEventListener('click', (e) => {
        e.preventDefault();
        
        // Remove active class from all house-trained options only
        houseOptions.forEach(opt => opt.classList.remove('trainingbook-step-5__option--active'));
        
        // Add active class to clicked option
        option.classList.add('trainingbook-step-5__option--active');
        
        const selectedHouseTrained = option.getAttribute('data-housetrained');
        
        // Track house-trained selection
        this.trackStepAnswer(5, 'house_trained', selectedHouseTrained);
      });
    });
    
  }

  setupStep6() {
    
    // Update question with dog's name
    const dogName = this.querySelector('#trainingbook_input_name')?.value?.trim() || 'Polly';
    const dogNameSpan = this.querySelector('#trainingbook_step6_dog_name');
    if (dogNameSpan) dogNameSpan.textContent = dogName;
    
    // Setup age selection
    const ageOptions = this.querySelectorAll('.trainingbook-step-6__age-option');
    ageOptions.forEach(option => {
      option.addEventListener('click', (e) => {
        e.preventDefault();
        
        // Remove active class from all age options
        ageOptions.forEach(opt => opt.classList.remove('trainingbook-step-6__age-option--active'));
        
        // Add active class to clicked option
        option.classList.add('trainingbook-step-6__age-option--active');
        
        const selectedAge = option.getAttribute('data-age');
        
        // Track age selection
        this.trackStepAnswer(6, 'age', selectedAge);
      });
    });
    
    // Setup meeting dropdown
    const meetingDropdown = this.querySelector('#trainingbook_step6_meeting');
    if (meetingDropdown) {
      meetingDropdown.addEventListener('change', (e) => {
        const selectedMeeting = e.target.value;
        
        // Track meeting selection
        this.trackStepAnswer(6, 'meeting', selectedMeeting);
      });
    }
    
  }

  setupStep7() {
    
    // Update questions with dog's name
    const dogName = this.querySelector('#trainingbook_input_name')?.value?.trim() || 'Polly';
    const dogNameSpans = this.querySelectorAll('#trainingbook_step7_dog_name, #trainingbook_step7_dog_name_2');
    dogNameSpans.forEach(span => {
      if (span) span.textContent = dogName;
    });
    
    // Setup attention selection
    const attentionOptions = this.querySelectorAll('.trainingbook-step-7__attention-option');
    attentionOptions.forEach(option => {
      option.addEventListener('click', (e) => {
        e.preventDefault();
        
        // Remove active class from all attention options
        attentionOptions.forEach(opt => opt.classList.remove('trainingbook-step-7__attention-option--active'));
        
        // Add active class to clicked option
        option.classList.add('trainingbook-step-7__attention-option--active');
        
        const selectedAttention = option.getAttribute('data-attention');
        
        // Track attention selection
        this.trackStepAnswer(7, 'attention', selectedAttention);
      });
    });
    
    // Setup meaning dropdown
    const meaningDropdown = this.querySelector('#trainingbook_step7_meaning');
    if (meaningDropdown) {
      meaningDropdown.addEventListener('change', (e) => {
        const selectedMeaning = e.target.value;
        
        // Track meaning selection
        this.trackStepAnswer(7, 'meaning', selectedMeaning);
      });
    }
    
  }

  setupStep8() {
    
    // Inject CSS directly to ensure styles are applied
    if (!document.getElementById('trainingbook-checkbox-styles')) {
      const style = document.createElement('style');
      style.id = 'trainingbook-checkbox-styles';
      style.textContent = `
        .trainingbook-step-8__goal-item--selected {
          background: #ED931B !important;
          background-color: #ED931B !important;
        }
        .trainingbook-step-8__goal-item--selected span {
          color: #FFFFFF !important;
        }
        .trainingbook-step-8__goal-item--selected .trainingbook-step-8__checkbox {
          background: #ffffff !important;
          border-color: #363636 !important;
        }
        .trainingbook-step-8__goal-item--selected .trainingbook-step-8__checkbox::after {
          content: '✓' !important;
          color: #363636 !important;
          font-weight: bold !important;
          font-size: 12px !important;
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
          position: absolute !important;
        }
        .trainingbook-step-9__stress-item--selected {
          background: #ED931B !important;
          background-color: #ED931B !important;
        }
        .trainingbook-step-9__stress-item--selected span {
          color: #FFFFFF !important;
        }
        .trainingbook-step-9__stress-item--selected .trainingbook-step-9__checkbox {
          background: #ffffff !important;
          border-color: #363636 !important;
        }
        .trainingbook-step-9__stress-item--selected .trainingbook-step-9__checkbox::after {
          content: '✓' !important;
          color: #363636 !important;
          font-weight: bold !important;
          font-size: 12px !important;
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
          position: absolute !important;
        }
        .trainingbook-step-10__topic-item--selected {
          background: #ED931B !important;
          background-color: #ED931B !important;
        }
        .trainingbook-step-10__topic-item--selected span {
          color: #FFFFFF !important;
        }
        .trainingbook-step-10__topic-item--selected .trainingbook-step-10__checkbox {
          background: #ffffff !important;
          border-color: #363636 !important;
        }
        .trainingbook-step-10__topic-item--selected .trainingbook-step-10__checkbox::after {
          content: '✓' !important;
          color: #363636 !important;
          font-weight: bold !important;
          font-size: 12px !important;
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
          position: absolute !important;
        }
      `;
      document.head.appendChild(style);
    }
    
    // Setup training goals selection with proper toggle behavior
    const goalItems = this.querySelectorAll('.trainingbook-step-8__goal-item');
    const goalContainer = this.querySelector('.trainingbook-step-8__goals-container');

    if(goalContainer.classList.contains('initalized')) {
      return;
    }
    
    goalItems.forEach((item, index) => {
      
      // Add multiple event listeners to ensure it works
      item.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        
        const goalValue = item.getAttribute('data-goal');
        
        // Simple toggle logic
        if (item.classList.contains('trainingbook-step-8__goal-item--selected')) {
          // Deselect item
          item.classList.remove('trainingbook-step-8__goal-item--selected');
          this.selectedGoals.delete(goalValue);
          // Reset inline styles
          item.style.backgroundColor = '#F7F6F1';
          const span = item.querySelector('span');
          if (span) span.style.color = '#363636';
        } else {
          // Select item
          item.classList.add('trainingbook-step-8__goal-item--selected');
          this.selectedGoals.add(goalValue);
          // Force visual change with inline styles
          item.style.backgroundColor = '#ED931B';
          const span = item.querySelector('span');
          if (span) span.style.color = '#FFFFFF';
        }
        
        // Force immediate visual update
        requestAnimationFrame(() => {
          item.style.transform = 'translateZ(0)';
          setTimeout(() => {
            item.style.transform = '';
          }, 10);
        });
        

        
        
        // Save form data when selection changes
        this.saveFormData();
        
        // Update validation for step 8
        this.updateNextEnabled();
      });
      
      // Also add mousedown event as backup
      item.addEventListener('mousedown', (e) => {
        e.preventDefault();
        e.stopPropagation();
      });
    });

    goalContainer.classList.add('initalized');
    
  }

  setupStep9() {
    
    // Update question with dog's name
    const dogName = this.querySelector('#trainingbook_input_name')?.value?.trim() || 'Polly';
    const dogNameSpan = this.querySelector('#trainingbook_step9_dog_name');
    if (dogNameSpan) dogNameSpan.textContent = dogName;
    
    // Setup stress situations selection with proper toggle behavior
    const stressItems = this.querySelectorAll('.trainingbook-step-9__stress-item');
    const goalContainer = this.querySelector('.trainingbook-step-9__stress-container');
  

    if(goalContainer.classList.contains('initalized')) {
      return;
    }
    
    stressItems.forEach((item, index) => {
      
      // Add multiple event listeners to ensure it works
      item.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        
        const stressValue = item.getAttribute('data-stress');
        
        // Simple toggle logic
        if (item.classList.contains('trainingbook-step-9__stress-item--selected')) {
          // Deselect item
          item.classList.remove('trainingbook-step-9__stress-item--selected');
          this.selectedStresses.delete(stressValue);
          // Reset inline styles
          item.style.backgroundColor = '#F7F6F1';
          const span = item.querySelector('span');
          if (span) span.style.color = '#363636';
        } else {
          // Select item
          item.classList.add('trainingbook-step-9__stress-item--selected');
          this.selectedStresses.add(stressValue);
          // Force visual change with inline styles
          item.style.backgroundColor = '#ED931B';
          const span = item.querySelector('span');
          if (span) span.style.color = '#FFFFFF';
        }
        
        // Force immediate visual update
        requestAnimationFrame(() => {
          item.style.transform = 'translateZ(0)';
          setTimeout(() => {
            item.style.transform = '';
          }, 10);
        });
        
        
        // Save form data when selection changes
        this.saveFormData();
        
        // Update validation for step 9
        this.updateNextEnabled();
      });
      
      // Also add mousedown event as backup
      item.addEventListener('mousedown', (e) => {
        e.preventDefault();
        e.stopPropagation();
      });
    });

    goalContainer.classList.add('initalized');
    
  }

  setupStep10() {
    
    // Setup training topics selection with proper toggle behavior
    const topicItems = this.querySelectorAll('.trainingbook-step-10__topic-item');
     const goalContainer = this.querySelector('.trainingbook-step-10__topics-container');
   
    if(goalContainer.classList.contains('initalized')) {
      return;
    }
    
    topicItems.forEach((item, index) => {
      
      // Add multiple event listeners to ensure it works
      item.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        
        const topicValue = item.getAttribute('data-topic');
        
        // Simple toggle logic
        if (item.classList.contains('trainingbook-step-10__topic-item--selected')) {
          // Deselect item
          item.classList.remove('trainingbook-step-10__topic-item--selected');
          this.selectedTopics.delete(topicValue);
          // Reset inline styles
          item.style.backgroundColor = '#F7F6F1';
          const span = item.querySelector('span');
          if (span) span.style.color = '#363636';
        } else {
          // Select item
          item.classList.add('trainingbook-step-10__topic-item--selected');
          this.selectedTopics.add(topicValue);
          // Force visual change with inline styles
          item.style.backgroundColor = '#ED931B';
          const span = item.querySelector('span');
          if (span) span.style.color = '#FFFFFF';
        }
        
        // Force immediate visual update
        requestAnimationFrame(() => {
          item.style.transform = 'translateZ(0)';
          setTimeout(() => {
            item.style.transform = '';
          }, 10);
        });
        
        
        // Save form data when selection changes
        this.saveFormData();
        
        // Update validation for step 10
        this.updateNextEnabled();
      });
      
      // Also add mousedown event as backup
      item.addEventListener('mousedown', (e) => {
        e.preventDefault();
        e.stopPropagation();
      });
    });

    goalContainer.classList.add('initalized');
    
  }

  resetStep8Checkboxes() {
    // Clear the selected goals set
    this.selectedGoals.clear();
    
    // Remove selected class from all goal items and reset styles
    const goalItems = this.querySelectorAll('.trainingbook-step-8__goal-item');
    goalItems.forEach(item => {
      item.classList.remove('trainingbook-step-8__goal-item--selected');
      item.style.backgroundColor = '#F7F6F1';
      const span = item.querySelector('span');
      if (span) span.style.color = '#363636';
      
      // Remove all existing event listeners by cloning the element
      const newItem = item.cloneNode(true);
      item.parentNode.replaceChild(newItem, item);
    });
    
  }

  resetStep9Checkboxes() {
    // Clear the selected stresses set
    this.selectedStresses.clear();
    
    // Remove selected class from all stress items and reset styles
    const stressItems = this.querySelectorAll('.trainingbook-step-9__stress-item');
    stressItems.forEach(item => {
      item.classList.remove('trainingbook-step-9__stress-item--selected');
      item.style.backgroundColor = '#F7F6F1';
      const span = item.querySelector('span');
      if (span) span.style.color = '#363636';
      
      // Remove all existing event listeners by cloning the element
      const newItem = item.cloneNode(true);
      item.parentNode.replaceChild(newItem, item);
    });
    
  }

  resetStep10Checkboxes() {
    // Clear the selected topics set
    this.selectedTopics.clear();
    
    // Remove selected class from all topic items and reset styles
    const topicItems = this.querySelectorAll('.trainingbook-step-10__topic-item');
    topicItems.forEach(item => {
      item.classList.remove('trainingbook-step-10__topic-item--selected');
      item.style.backgroundColor = '#F7F6F1';
      const span = item.querySelector('span');
      if (span) span.style.color = '#363636';
      
      // Remove all existing event listeners by cloning the element
      const newItem = item.cloneNode(true);
      item.parentNode.replaceChild(newItem, item);
    });
    
  }

  setupStep11() {
    
    // Update question with dog's name
    const dogName = this.querySelector('#trainingbook_input_name')?.value?.trim() || 'Polly';
    const dogNameSpan = this.querySelector('#trainingbook_step11_dog_name');
    if (dogNameSpan) dogNameSpan.textContent = dogName;
    
    // Setup time selection
    const timeOptions = this.querySelectorAll('.trainingbook-step-11__time-option');
    timeOptions.forEach(option => {
      option.addEventListener('click', (e) => {
        e.preventDefault();
        
        // Remove active class from all options
        timeOptions.forEach(opt => opt.classList.remove('trainingbook-step-11__time-option--active'));
        
        // Add active class to clicked option
        option.classList.add('trainingbook-step-11__time-option--active');
        
        const selectedTime = option.getAttribute('data-time');
        
        // Track time selection
        this.trackStepAnswer(11, 'training_time', selectedTime);
      });
    });
    
    // Setup basic commands radio buttons
    const radioButtons = this.querySelectorAll('.trainingbook-step-11__radio');
    
    radioButtons.forEach((radio, index) => {
      
      radio.addEventListener('click', (e) => {
        e.preventDefault();
        
        // Remove active class from all radio buttons
        radioButtons.forEach(r => {
          r.classList.remove('trainingbook-step-11__radio--active');
        });
        
        // Add active class to clicked radio button
        radio.classList.add('trainingbook-step-11__radio--active');
        
        const selectedCommands = radio.getAttribute('data-commands');
        
        // Track basic commands selection
        this.trackStepAnswer(11, 'basic_commands', selectedCommands);
      });
    });
    
  }

  setupStep12() {
    
    // First, ensure we have captured the final SVG state if not already done
    let savedState = this.getFinalSVGState();
    if (!savedState || !savedState.completeSVG) {
      
      // Try to capture the SVG state from step 4 if available
      const step4Container = this.querySelector('#trainingbook_step4_container');
      if (step4Container && step4Container.querySelector('svg')) {
        savedState = this.captureFinalSVGState();
        if (savedState) {
        }
      }
    }
    
    // Display the saved SVG from step 4
    const finalPreviewContainer = this.querySelector('#trainingbook_final_preview_container');
    
    if (finalPreviewContainer) {
      const savedState = this.getFinalSVGState();
      
      if (savedState && savedState.completeSVG) {
        finalPreviewContainer.innerHTML = savedState.completeSVG;
      } else {
        console.warn('TrainingbookConfigDialog: ❌ No saved SVG state found, checking alternatives...');
        
        // Try to get from window object
        if (window.trainingbookFinalState && window.trainingbookFinalState.completeSVG) {
          finalPreviewContainer.innerHTML = window.trainingbookFinalState.completeSVG;
        } else {
          // Try localStorage
          try {
            const stored = localStorage.getItem('trainingbook_final_svg_state');
            if (stored) {
              const parsedState = JSON.parse(stored);
              if (parsedState.completeSVG) {
                finalPreviewContainer.innerHTML = parsedState.completeSVG;
              }
            } else {
              finalPreviewContainer.innerHTML = '<p style="color: #666; text-align: center; padding: 2rem;">Cover-Vorschau nicht verfügbar<br>Bitte kehre zu Schritt 4 zurück und stelle dein Cover fertig.</p>';
              console.error('TrainingbookConfigDialog: ❌ No SVG state found anywhere!');
            }
          } catch (e) {
            finalPreviewContainer.innerHTML = '<p style="color: #666; text-align: center; padding: 2rem;">Fehler beim Laden der Cover-Vorschau</p>';
            console.error('TrainingbookConfigDialog: Error loading from localStorage:', e);
          }
        }
      }
      
      // After displaying the SVG, render it in tee-mockup-zoomable elements
      if (finalPreviewContainer.querySelector('svg')) {
        
        // Render the final SVG in all tee-mockup-zoomable elements
        this.renderFinalSVGInTeeMockupZoomable();
        
        // Ensure the SVG is properly rendered in the first slide
        setTimeout(() => {
          this.ensureSVGInFirstSlide();
        }, 200);
        
      } else {
        console.warn('TrainingbookConfigDialog: No SVG found in step 12, cannot render in tee-mockup-zoomable');
      }
      
      // Set up a mutation observer to watch for changes in step 4 that might affect the final SVG
      this.setupStep4MutationObserver();
    } else {
      console.error('TrainingbookConfigDialog: CRITICAL - Final preview container not found!');
    }
    
    // Save the order data
    this.saveOrder();
    
    // Log all the values that will be saved to line item properties
    
  }

  // Set up mutation observer to watch for changes in step 4 that affect the final SVG
  setupStep4MutationObserver() {
    try {
      
      const step4Container = this.querySelector('#trainingbook_step4_container');
      if (!step4Container) {
        console.warn('TrainingbookConfigDialog: Step 4 container not found for mutation observer');
        return;
      }
      
      // Create a mutation observer to watch for changes in step 4
      const observer = new MutationObserver((mutations) => {
        let svgChanged = false;
        
        mutations.forEach((mutation) => {
          if (mutation.type === 'childList' || mutation.type === 'attributes') {
            // Check if SVG content has changed
            const svgElement = step4Container.querySelector('svg');
            if (svgElement) {
              svgChanged = true;
            }
          }
        });
        
        if (svgChanged) {
          
          // Update step 12 with the new SVG state
          setTimeout(() => {
            this.updateStep12WithNewSVG();
          }, 100);
        }
      });
      
      // Start observing
      observer.observe(step4Container, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['style', 'transform']
      });
      
      // Store the observer for cleanup
      this.step4MutationObserver = observer;
      
    } catch (e) {
      console.error('TrainingbookConfigDialog: Error setting up step 4 mutation observer:', e);
    }
  }

  // Update step 12 with new SVG from step 4
  updateStep12WithNewSVG() {
    try {
      
      // Capture the new SVG state
      const newState = this.captureFinalSVGState();
      if (newState && newState.completeSVG) {
        // Update step 12 display
        const finalPreviewContainer = this.querySelector('#trainingbook_final_preview_container');
        if (finalPreviewContainer) {
          finalPreviewContainer.innerHTML = newState.completeSVG;
          
          // Update tee-mockup-zoomable elements with the new SVG
          this.renderFinalSVGInTeeMockupZoomable();
          
          setTimeout(() => {
            this.ensureSVGInFirstSlide();
          }, 200);
        }
      }
    } catch (e) {
      console.error('TrainingbookConfigDialog: Error updating step 12 with new SVG:', e);
    }
  }

  ensureUI() {
    // Step 4: Now uses static HTML from the template instead of dynamic generation
    const s4 = this.steps[4];
    if (s4 && !s4.dataset.inited) {
      // No longer generating HTML here - using the template HTML instead
      s4.dataset.inited = 'true';
      
      // Color selection functionality is now handled in setupStep4()
    }

    // Step 5: Now uses static HTML from the template instead of dynamic generation
    const s5 = this.steps[5];
    if (s5 && !s5.dataset.inited) {
      // No longer generating HTML here - using the template HTML instead
      s5.dataset.inited = 'true';
      
      // Gender and house-trained functionality is now handled in setupStep5()
    }

    // Step 6: Now uses static HTML from the template instead of dynamic generation
    const s6 = this.steps[6];
    if (s6 && !s6.dataset.inited) {
      // No longer generating HTML here - using the template HTML instead
      s6.dataset.inited = 'true';
      
      // Age and meeting functionality is now handled in setupStep6()
    }

    // Step 7: Now uses static HTML from the template instead of dynamic generation
    const s7 = this.steps[7];
    if (s7 && !s7.dataset.inited) {
      // No longer generating HTML here - using the template HTML instead
      s7.dataset.inited = 'true';
      
      // Attention and meaning functionality is now handled in setupStep7()
    }

    // Step 8: Now uses static HTML from the template instead of dynamic generation
    const s8 = this.steps[8];
    if (s8 && !s8.dataset.inited) {
      // No longer generating HTML here - using the template HTML instead
      s8.dataset.inited = 'true';
      
      // Training goals functionality is now handled in setupStep8()
    }

    // Step 9: Now uses static HTML from the template instead of dynamic generation
    const s9 = this.steps[9];
    if (s9 && !s9.dataset.inited) {
      // No longer generating HTML here - using the template HTML instead
      s9.dataset.inited = 'true';
      
      // Stress situations functionality is now handled in setupStep9()
    }

    // Step 10: Now uses static HTML from the template instead of dynamic generation
    const s10 = this.steps[10];
    if (s10 && !s10.dataset.inited) {
      // No longer generating HTML here - using the template HTML instead
      s10.dataset.inited = 'true';
      
      // Training topics functionality is now handled in setupStep10()
    }

    // Step 11: Now uses static HTML from the template instead of dynamic generation
    const s11 = this.steps[11];
    if (s11 && !s11.dataset.inited) {
      // No longer generating HTML here - using the template HTML instead
      s11.dataset.inited = 'true';
      
      // Time and basic commands functionality is now handled in setupStep11()
    }

    // Step 12: Now uses static HTML from the template instead of dynamic generation
    const s12 = this.steps[12];
    if (s12 && !s12.dataset.inited) {
      // No longer generating HTML here - using the template HTML instead
      s12.dataset.inited = 'true';
      
      // SVG display functionality is now handled in setupStep12()
    }
  }

  toggleDialog() {
    this.showDialog = !this.showDialog;
    this.querySelector('.product-wimmelbuch__config--dialog').style.display = this.showDialog ? 'flex' : 'none';
    if (this.showDialog) {
      this.showStep(1);
      // Only restore data if configurator was previously completed
      this.checkAndRestoreData();
      
      // Initialize validation when dialog opens
      setTimeout(() => {
        this.updateNextEnabled();
      }, 200);
    } else {
      // If dialog is being closed and we're on step 12, add the thumbnail
      if (this.step === 12) {
        setTimeout(() => {
          this.replaceProductThumbnail();
        }, 100);
      }
    }
  }

  showStep(n) {
    const previousStep = this.step;
    this.step = Math.min(Math.max(1, n), this.totalSteps);
    
    // Track step progression
    if (previousStep !== this.step) {
      const stepData = this.collectStepData(previousStep);
      this.trackStepProgression(previousStep, this.step, stepData);
      this.trackStepCompletion(previousStep, stepData);
    }
    
    this.steps.forEach((el, idx) => {
      if (!el) return;
      el.style.display = (idx === this.step) ? 'block' : 'none';
    });
    if (this.stepText) this.stepText.innerHTML = String(this.step);
    if (this.buttonBack) this.buttonBack.disabled = this.step === 1;
    
    // Update button text based on step
    if (this.buttonNext) {
      if (this.step === 1) {
        this.buttonNext.innerHTML = "Los geht's";
      } else if (this.step === 12) {
        this.buttonNext.innerHTML = "Abschließen";
      } else {
        this.buttonNext.innerHTML = "Weiter";
      }
    }
    
    // Update step 2 header with dog name
    if (this.step === 2) {
      const dogName = this.querySelector('#trainingbook_input_name')?.value?.trim() || 'deinem Hund';
      const step2Header = this.querySelector('.trainingbook-step-2__header');
      if (step2Header) {
        step2Header.textContent = `Lade hier ein schönes Foto von ${dogName} hoch`;
      }
    }
    
    if (this.step === 4) {
      // Setup step 4 functionality
      this.setupStep4();
    }
    
    if (this.step === 5) {
      // Setup step 5 functionality
      this.setupStep5();
    }
    
    if (this.step === 6) {
      // Setup step 6 functionality
      this.setupStep6();
    }
    
    if (this.step === 7) {
      // Setup step 7 functionality
      this.setupStep7();
    }
    
    if (this.step === 8) {
      // Reset step 8 checkboxes before setup
      //this.resetStep8Checkboxes();
      // Setup step 8 functionality
      this.setupStep8();
    }
    
    if (this.step === 9) {
      // Reset step 9 checkboxes before setup
      //this.resetStep9Checkboxes();
      // Setup step 9 functionality
      this.setupStep9();
    }
    
    if (this.step === 10) {
      // Reset step 10 checkboxes before setup
      //this.resetStep10Checkboxes();
      // Setup step 10 functionality
      this.setupStep10();
    }
    
    if (this.step === 11) {
      // Setup step 11 functionality
      this.setupStep11();
    }
    
    if (this.step === 12) {
      // Setup step 12 functionality
      this.setupStep12();
    }
    
    this.updateNextEnabled();
    if (this.step === 3) {
      // Disable the next button during loading
      if (this.buttonNext) this.buttonNext.disabled = true;
      
      // Start slower progress animation
      this.startProgressAnimation();
    } else {
      // Re-enable button for other steps
      if (this.buttonNext) this.buttonNext.disabled = false;
    }
    
    // Trigger validation after step is shown
    setTimeout(() => {
      this.updateNextEnabled();
    }, 100);
  }

  nextStep() {
    
    // CRITICAL: Capture SVG state when leaving step 4
    if (this.step === 4) {
      const capturedState = this.captureFinalSVGState();
      if (capturedState) {
      } else {
        console.error('TrainingbookConfigDialog: ❌ CRITICAL ERROR - FAILED TO CAPTURE SVG STATE!');
      }
    }
    
    // Handle step 12 completion - close the configurator
    if (this.step === 12) {
      
      // Track final step completion and overall configurator completion
      const finalStepData = this.collectStepData(12);
      this.trackStepCompletion(12, finalStepData);
      this.trackConfiguratorCompletion();
      
      // Note: SVG rendering is now handled in setupStep12()
      
      this.markConfiguratorCompleted(); // Mark as completed
      this.toggleDialog(); // Close the dialog
      return;
    }
    
    // Step 1 no longer blocks navigation – still keep visual cue
    if (this.step < this.totalSteps) {
      this.showStep(this.step + 1);
    } else {
    }
  }

  previousStep() {
    if (this.step > 1) {
      if(this.step == 4){
        this.showStep(this.step - 2);
        return
      }
      this.showStep(this.step - 1);
    }
  }

  saveOrder() {
    const form = document.querySelector('.product-wimmelbuch__form-wrapper form[action*="/cart/add"]');
    if (!form) return;
    const ensure = (name, value) => {
      let input = form.querySelector(`[name="properties[${name}]"]`);
      if (!input) { input = document.createElement('input'); input.type = 'hidden'; input.name = `properties[${name}]`; form.appendChild(input); }
      input.value = value;
    };
    
    ensure('_training_name', this.querySelector('#trainingbook_input_name')?.value || '');
    ensure('_training_breed', this.querySelector('#trainingbook_breed_select')?.value || '');
    ensure('_training_cover_color', (document.querySelector(".trainingbook-step-4__color-option.trainingbook-step-4__color-option--active")?.dataset?.color) || '');
    ensure('_training_cutout_image', this.processedImageUrl);
    
    // Also persist precise cutout transform (x, y, zoom) as separate properties
    try {
      let x = 0, y = 0, scale = 1;
      if (this.currentDogTransform && typeof this.currentDogTransform.x === 'number') {
        x = this.currentDogTransform.x;
        y = this.currentDogTransform.y;
        scale = this.currentDogTransform.scale || 1;
      } else {
        // Fallback: parse from existing SVG transform (step 12 or step 4)
        const svg = document.querySelector('#trainingbook_final_preview_container svg')
                  || document.querySelector('#trainingbook_cover_preview_container svg');
        const group = svg ? svg.querySelector('#draggable-dog-group') : null;
        const transformStr = group ? group.getAttribute('transform') : (this.getFinalSVGState()?.dogTransform || '');
        if (transformStr) {
          const translateMatch = transformStr.match(/translate\(([^,]+),\s*([^)]+)\)/);
          const scaleMatch = transformStr.match(/scale\(([^)]+)\)/);
          if (translateMatch) {
            x = parseFloat(translateMatch[1]);
            y = parseFloat(translateMatch[2]);
          }
          if (scaleMatch) {
            scale = parseFloat(scaleMatch[1]);
          }
        }
      }
      ensure('_training_cutout_image_x', String(x));
      ensure('_training_cutout_image_y', String(y));
      ensure('_training_cutout_image_zoom', String(scale));
    } catch (e) {
      console.warn('TrainingbookConfigDialog: Could not save cutout transform properties', e);
    }
    
  }

  setupValidationEventListeners() {
    // Step 6 validation: meeting dropdown
    const meetingSelect = this.querySelector('#trainingbook_step6_meeting');
    if (meetingSelect) {
      meetingSelect.addEventListener('change', () => {
        this.updateNextEnabled();
        this.trackStepAnswer(6, 'meeting', meetingSelect.value);
      });
    }
    
    // Step 7 validation: meaning dropdown
    const meaningSelect = this.querySelector('#trainingbook_step7_meaning');
    if (meaningSelect) {
      meaningSelect.addEventListener('change', () => {
        this.updateNextEnabled();
        this.trackStepAnswer(7, 'meaning', meaningSelect.value);
      });
    }
    
    // Step 8 validation: goals checkboxes
    const goalCheckboxes = this.querySelectorAll('.trainingbook-step-8__goal-item input[type="checkbox"]');
    goalCheckboxes.forEach(checkbox => {
      checkbox.addEventListener('change', () => {
        this.updateNextEnabled();
        this.trackStepAnswer(8, 'goals', this.getSelectedGoals().join(', '));
      });
    });
    
    // Step 9 validation: stress checkboxes
    const stressCheckboxes = this.querySelectorAll('.trainingbook-step-9__stress-item input[type="checkbox"]');
    stressCheckboxes.forEach(checkbox => {
      checkbox.addEventListener('change', () => {
        this.updateNextEnabled();
        this.trackStepAnswer(9, 'stresses', this.getSelectedStresses().join(', '));
      });
    });
    
    // Step 10 validation: topic checkboxes
    const topicCheckboxes = this.querySelectorAll('.trainingbook-step-10__topic-item input[type="checkbox"]');
    topicCheckboxes.forEach(checkbox => {
      checkbox.addEventListener('change', () => {
        this.updateNextEnabled();
        this.trackStepAnswer(10, 'topics', this.getSelectedTopics().join(', '));
      });
    });
  }

  updateNextEnabled() {
    // Get all next buttons for different steps
    const losGehtsButton = this.querySelector('.trainingbook-step-1__losgehts-btn');
    const coverErstellenButton = this.querySelector('.step-nav-btn--next');
    const weiterButtons = this.querySelectorAll('.step-nav-btn--next');
    
    // Step 1 validation: name and breed required
    if (this.step === 1 && losGehtsButton) {
      const nameVal = (this.querySelector('#trainingbook_input_name')?.value || '').trim();
      const breedVal = (this.querySelector('#trainingbook_breed_select')?.value || '').trim();
      const isValid = nameVal && breedVal;
      
      losGehtsButton.disabled = !isValid;
      losGehtsButton.classList.toggle('button--disabled', !isValid);
    }
    
    // Step 2 validation: image uploaded
    if (this.step === 2 && coverErstellenButton) {
      const hasImage = this.hasCutoutImage();
      coverErstellenButton.disabled = !hasImage;
      coverErstellenButton.classList.toggle('button--disabled', !hasImage);
    }
    
    // Step 6 validation: answer to "Wie habt ihr euch kennengelernt?"
    if (this.step === 6) {
      const meetingSelect = this.querySelector('#trainingbook_step6_meeting');
      const isValid = meetingSelect && meetingSelect.value && meetingSelect.value.trim() !== '';
      
      weiterButtons.forEach(button => {
        if (button.closest('#product-wimmelbuch__config--dialog__step-6')) {
          button.disabled = !isValid;
          button.classList.toggle('button--disabled', !isValid);
        }
      });
    }
     
    // Step 7 validation: answer to "Was ist ... für dich?"
    if (this.step === 7) {
      const meaningSelect = this.querySelector('#trainingbook_step7_meaning');
      const isValid = meaningSelect && meaningSelect.value && meaningSelect.value.trim() !== '';
      
      weiterButtons.forEach(button => {
        if (button.closest('#product-wimmelbuch__config--dialog__step-7')) {
          button.disabled = !isValid;
          button.classList.toggle('button--disabled', !isValid);
        }
      });
    }
    
    // Step 8 validation: at least one answer selected
    if (this.step === 8) {
      const selectedGoals = this.getSelectedGoals();
      const isValid = selectedGoals.length > 0;
      
      weiterButtons.forEach(button => {
        if (button.closest('#product-wimmelbuch__config--dialog__step-8')) {
          button.disabled = !isValid;
          button.classList.toggle('button--disabled', !isValid);
        }
      });
    }
    
    // Step 9 validation: at least one answer selected
    if (this.step === 9) {
      const selectedStresses = this.getSelectedStresses();
      const isValid = selectedStresses.length > 0;
      
      weiterButtons.forEach(button => {
        if (button.closest('#product-wimmelbuch__config--dialog__step-9')) {
          button.disabled = !isValid;
          button.classList.toggle('button--disabled', !isValid);
        }
      });
    }
    
    // Step 10 validation: at least one answer selected
    if (this.step === 10) {
      const selectedTopics = this.getSelectedTopics();
      const isValid = selectedTopics.length > 0;
      
      weiterButtons.forEach(button => {
        if (button.closest('#product-wimmelbuch__config--dialog__step-10')) {
          button.disabled = !isValid;
          button.classList.toggle('button--disabled', !isValid);
        }
      });
    }
  }

  updateCharacterCounter() {
    const nameInput = this.querySelector('#trainingbook_input_name');
    const charCounter = this.querySelector('#trainingbook_char_counter');
    
    if (!nameInput || !charCounter) return;
    
    const currentLength = nameInput.value.length;
    const maxLength = 12;
    
    charCounter.textContent = `${currentLength}/${maxLength}`;
    
    // Add warning style if close to limit
    if (currentLength >= maxLength - 2) {
      charCounter.classList.add('warning');
    } else {
      charCounter.classList.remove('warning');
    }
    
    // Update name scaling in step 4 if currently viewing it
    const coverContainer = this.querySelector('#trainingbook_cover_container');
    if (coverContainer && coverContainer.querySelector('.trainingbook-overlay--text text')) {
      const dogName = nameInput.value.trim();
      const displayName = dogName.length > 0 ? dogName.toUpperCase() : 'HUNDENAME';
      
      // Update the displayed name
      const dogNameDisplay = coverContainer.querySelector('#dog-name-display');
      if (dogNameDisplay) {
        dogNameDisplay.textContent = displayName;
      }
      
      // Apply dynamic scaling
      this.updateNameScaling(coverContainer, displayName.length);
    }
  }

  // Form data persistence methods for steps 8, 9, and 10
  saveFormData() {
    const formData = {
      step8: {
        goals: this.getSelectedGoals()
      },
      step9: {
        stresses: this.getSelectedStresses()
      },
      step10: {
        topics: this.getSelectedTopics()
      }
    };
    
    // Track checkbox selections for GA4
    if (formData.step8.goals.length > 0) {
      this.trackStepAnswer(8, 'training_goals', formData.step8.goals.join(', '));
    }
    if (formData.step9.stresses.length > 0) {
      this.trackStepAnswer(9, 'stress_factors', formData.step9.stresses.join(', '));
    }
    if (formData.step10.topics.length > 0) {
      this.trackStepAnswer(10, 'training_topics', formData.step10.topics.join(', '));
    }
    
    try {
      localStorage.setItem('trainingbook_form_data', JSON.stringify(formData));
    } catch (e) {
      console.warn('TrainingbookConfigDialog: Could not save form data to localStorage:', e);
    }
  }

  loadSavedFormData() {
    // This method is called when dialog opens, but we need to restore data when navigating to specific steps
    // The actual restoration is handled in showStep when navigating to steps 8, 9, and 10
  }



  getSelectedGoals() {
    return Array.from(this.selectedGoals);
  }

  getSelectedStresses() {
    return Array.from(this.selectedStresses);
  }

  getSelectedTopics() {
    return Array.from(this.selectedTopics);
  }

  replaceProductThumbnail() {
    
    try {
      // Get the generated cover from step 12 (could be img or svg)
      const coverContainer = this.querySelector('#trainingbook_final_preview_container');
      let coverImageUrl = null;
      
      // Try to find an img element first
      const generatedCoverImage = coverContainer ? coverContainer.querySelector('img') : null;
      if (generatedCoverImage) {
        coverImageUrl = generatedCoverImage.src;
      } else {
        // If no img, try to find SVG and convert it
        const generatedCoverSVG = coverContainer ? coverContainer.querySelector('svg') : null;
        if (generatedCoverSVG) {
          const svgData = new XMLSerializer().serializeToString(generatedCoverSVG);
          const svgBlob = new Blob([svgData], { type: 'image/svg+xml;charset=utf-8' });
          coverImageUrl = URL.createObjectURL(svgBlob);
        }
      }
      
      if (!coverImageUrl) {
        console.warn('TrainingbookConfigDialog: No cover image or SVG found in step 12');
        return;
      }
      
      // Find the tee-thumbnails track - this is where the thumbnails are
      let thumbnailTrack = document.querySelector('.tee-thumbnails__track');
      
      
      if (!thumbnailTrack) {
        console.error('TrainingbookConfigDialog: No thumbnail track found');
        return;
      }
      
      // Create new thumbnail item matching the tee-thumbnail structure exactly
      const newThumbnailItem = document.createElement('div');
      newThumbnailItem.className = 'tee-thumbnail tee-thumbnail-img--1-1';
      newThumbnailItem.style.cssText = 'width: 129.25px; height: 129.25px;';
      
      // Create the mockup item structure
      const mockupItem = document.createElement('div');
      mockupItem.className = 'tee-mockup-item tee-mockup-item--loaded';
      
      // Create the mockup container
      const mockup = document.createElement('div');
      mockup.className = 'tee-mockup';
      mockup.style.cssText = 'width: 129.25px; height: 129.25px;';
      
      // Create the mockup image container
      const mockupImage = document.createElement('div');
      mockupImage.className = 'tee-mockup-image';
      mockupImage.style.cssText = 'width: 129.25px; height: 129.25px;';
      
      // Create the printarea wrapper for our custom cover
      const printareaWrapper = document.createElement('div');
      printareaWrapper.className = 'tee-printarea-wrapper tee-printarea-wrapper--image';
      printareaWrapper.style.cssText = 'display: block; top: 0px; left: 0px; width: 129.25px; height: 129.25px; transform: rotate(0deg); opacity: 1;';
      
      // Create the actual image
      const coverImage = document.createElement('img');
      coverImage.src = coverImageUrl;
      coverImage.alt = 'Personalisiertes Trainingsbuch Cover';
      coverImage.style.cssText = 'width: 100%; height: 100%; object-fit: cover; border-radius: 4px;';
      
      // Add click handler to the entire thumbnail to show in main gallery
      newThumbnailItem.addEventListener('click', (e) => {
        e.preventDefault();
        // Use the proper slider navigation to go to the first slide
        const firstDot = document.querySelector('.tee-slider__dots li:first-child button');
        if (firstDot) {
          firstDot.click();
        } else {
          // Fallback: manually trigger the first slide
          const mainGalleryTrack = document.querySelector('.tee-slider__track');
          if (mainGalleryTrack && mainGalleryTrack.children.length > 0) {
            // Use the slider's own navigation system
            const sliderComponent = document.querySelector('slider-component');
            if (sliderComponent && typeof sliderComponent.goToSlide === 'function') {
              sliderComponent.goToSlide(0);
            } else {
              // Last resort: trigger click on first dot
              const dots = document.querySelectorAll('.tee-slider__dots li button');
              if (dots.length > 0) {
                dots[0].click();
              }
            }
          }
        }
      });
      
      // Convert SVG to PNG and download it
      this.convertSvgToPngAndDownload(coverImageUrl);
      
      // Assemble the thumbnail structure
      printareaWrapper.appendChild(coverImage);
      mockup.appendChild(mockupImage);
      mockup.appendChild(printareaWrapper);
      mockupItem.appendChild(mockup);
      newThumbnailItem.appendChild(mockupItem);
      
      // Add to thumbnail track as the FIRST thumbnail
      thumbnailTrack.insertBefore(newThumbnailItem, thumbnailTrack.firstChild);
      // Update the thumbnail track width to accommodate the new thumbnail
      const currentTransform = thumbnailTrack.style.transform;
      
      // Calculate new width for the track to show all thumbnails
      const thumbnailWidth = 129.25;
      const thumbnailMargin = 5; // Assuming 5px margin between thumbnails
      const totalThumbnails = thumbnailTrack.children.length;
      const newTrackWidth = totalThumbnails * (thumbnailWidth + thumbnailMargin);
      
      // Update the track width
      thumbnailTrack.style.width = `${newTrackWidth}px`;
      

      
      // Also add to main gallery slides
      const mainGalleryTrack = document.querySelector('.tee-slider__track');
      if (mainGalleryTrack) {
        const newSlide = document.createElement('div');
        newSlide.className = 'tee-slide';
        newSlide.style.cssText = 'width: 532px; height: 532px;';
        
        const slideContent = document.createElement('div');
        slideContent.className = 'tee-mockup-zoomable';
        slideContent.innerHTML = `
          <div class="tee-mockup-item tee-mockup-item--loaded">
            <div class="tee-mockup" style="width: 532px; height: 532px;">
              <div class="tee-mockup-image" style="width: 532px; height: 532px;"></div>
              <div class="tee-printarea-wrapper tee-printarea-wrapper--image" style="display: block; top: 0px; left: 0px; width: 532px; height: 532px; transform: rotate(0deg); opacity: 1;">
                <img src="${coverImageUrl}" alt="Personalisiertes Trainingsbuch Cover" style="width: 100%; height: 100%; object-fit: cover;">
              </div>
            </div>
          </div>
        `;
        
        newSlide.appendChild(slideContent);
        mainGalleryTrack.insertBefore(newSlide, mainGalleryTrack.firstChild);
        
        // Update the dots navigation
        const dotsContainer = document.querySelector('.tee-slider__dots');
        if (dotsContainer) {
          const newDot = document.createElement('li');
          newDot.innerHTML = '<button type="button">1</button>';
          dotsContainer.insertBefore(newDot, dotsContainer.firstChild);
        }
      }
      
      
      // Log all existing thumbnails
      const allThumbnails = thumbnailTrack.querySelectorAll('.tee-thumbnail');
      allThumbnails.forEach((thumb, index) => {
      });
      
      // Log all slides in main gallery
      const allSlides = document.querySelectorAll('.tee-slide');
      allSlides.forEach((slide, index) => {
      });
      
      // Log all dots
      const allDots = document.querySelectorAll('.tee-slider__dots li');
      allDots.forEach((dot, index) => {
      });
      
      // Force a reflow and check again
      setTimeout(() => {
        const customThumbnail = document.getElementById('tee-thumbnail-custom-cover');
        if (customThumbnail) {
        }
        
        // Check all thumbnails again
        const allThumbnailsAfter = thumbnailTrack.querySelectorAll('.tee-thumbnail');
        allThumbnailsAfter.forEach((thumb, index) => {
        });
        

      }, 500);
      

      

      

      
      // Store the cover URL for potential use
      this.generatedCoverUrl = coverImageUrl;
      

      
    } catch (error) {
      console.error('TrainingbookConfigDialog: Error adding cover to thumbnail gallery:', error);
    }
  }

  convertSvgToPngAndDownload(coverImageUrl) {
    
    try {
      // Create a canvas element
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      
      // Set canvas size (you can adjust these dimensions)
      canvas.width = 800;
      canvas.height = 600;
      
      // Create an image element
      const img = new Image();
      img.crossOrigin = 'anonymous';
      
      img.onload = () => {
        // Draw the image on canvas
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
        
        // Convert canvas to blob
        canvas.toBlob((blob) => {
          // Create download link
          const url = URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = `trainingbook-cover-${Date.now()}.png`;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          URL.revokeObjectURL(url);
          
        }, 'image/png');
      };
      
      img.onerror = () => {
        console.error('TrainingbookConfigDialog: Failed to load image for conversion');
      };
      
      // Set the image source
      img.src = coverImageUrl;
      
    } catch (error) {
      console.error('TrainingbookConfigDialog: Error converting SVG to PNG:', error);
    }
  }

  addThumbnailFallback(coverUrl) {
    
    try {
      // Try to find any thumbnail container
      const containers = [
        '.tee-thumbnails__track',
        '.tee-thumbnails',
        '.tee-gallery',
        '.thumbnail-slider',
        '.product__media-wrapper',
        '.product__media-gallery',
        '[class*="thumbnail"]'
      ];
      
      let container = null;
      for (const selector of containers) {
        container = document.querySelector(selector);
        if (container) {
          break;
        }
      }
      
      if (!container) {
        console.error('TrainingbookConfigDialog: No container found for fallback');
        return;
      }
      
      // Create a simple thumbnail and add it directly to the container
      const thumbnailDiv = document.createElement('div');
      thumbnailDiv.style.cssText = `
        display: inline-block !important;
        width: 100px !important;
        height: 100px !important;
        margin: 5px !important;
        border: 2px solid #ED931B !important;
        border-radius: 8px !important;
        cursor: pointer !important;
        background: white !important;
        position: relative !important;
        z-index: 1000 !important;
      `;
      
      const img = document.createElement('img');
      img.src = coverUrl;
      img.alt = 'Personalisiertes Cover';
      img.style.cssText = `
        width: 100% !important;
        height: 100% !important;
        object-fit: cover !important;
        border-radius: 6px !important;
      `;
      
      thumbnailDiv.appendChild(img);
      container.appendChild(thumbnailDiv);
      
      // Add click handler
      thumbnailDiv.addEventListener('click', () => {
        this.showCustomCoverInMainGallery(coverUrl);
      });
      
      
    } catch (error) {
      console.error('TrainingbookConfigDialog: Fallback method also failed:', error);
    }
  }

  showCustomCoverInMainGallery(coverUrl) {
    
    try {
      // Find the main gallery viewer
      const galleryViewer = document.querySelector('.slider-mobile-gutter');
      if (!galleryViewer) {
        console.warn('TrainingbookConfigDialog: Main gallery viewer not found');
        return;
      }
      
      // Create a temporary overlay to show the cover
      const overlay = document.createElement('div');
      overlay.style.cssText = `
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.9);
        z-index: 9999;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
      `;
      
      const coverImage = document.createElement('img');
      coverImage.src = coverUrl;
      coverImage.alt = 'Personalisiertes Trainingsbuch Cover';
      coverImage.style.cssText = `
        max-width: 90%;
        max-height: 90%;
        object-fit: contain;
        border-radius: 8px;
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
      `;
      
      overlay.appendChild(coverImage);
      document.body.appendChild(overlay);
      
      // Close overlay on click
      overlay.addEventListener('click', () => {
        document.body.removeChild(overlay);
      });
      
    } catch (error) {
      console.error('TrainingbookConfigDialog: Error showing custom cover in main gallery:', error);
    }
  }



  restoreStep8Data(data) {
    // Restore training goals selection
    /*if (data.goals && data.goals.length > 0) {
      const goalItems = this.querySelectorAll('.trainingbook-step-8__goal-item');
      
      // Clear the Set first
      this.selectedGoals.clear();
      
      goalItems.forEach(item => {
        const goalValue = item.getAttribute('data-goal');
        if (data.goals.includes(goalValue)) {
          item.classList.add('trainingbook-step-8__goal-item--selected');
          this.selectedGoals.add(goalValue);
        } else {
          item.classList.remove('trainingbook-step-8__goal-item--selected');
        }
      });
    }*/
  }

  restoreStep9Data(data) {
    /*// Restore stress situations selection
    if (data.stresses && data.stresses.length > 0) {
      const stressItems = this.querySelectorAll('.trainingbook-step-9__stress-item');
      
      // Clear the Set first
      this.selectedStresses.clear();
      
      stressItems.forEach(item => {
        const stressValue = item.getAttribute('data-stress');
        if (data.stresses.includes(stressValue)) {
          item.classList.add('trainingbook-step-9__stress-item--selected');
          this.selectedStresses.add(stressValue);
        } else {
          item.classList.remove('trainingbook-step-9__stress-item--selected');
        }
      });
    }*/
  }

  restoreStep10Data(data) {
    /*// Restore training topics selection
    if (data.topics && data.topics.length > 0) {
      const topicItems = this.querySelectorAll('.trainingbook-step-10__topic-item');
      
      // Clear the Set first
      this.selectedTopics.clear();
      
      topicItems.forEach(item => {
        const topicValue = item.getAttribute('data-topic');
        if (data.topics.includes(topicValue)) {
          item.classList.add('trainingbook-step-10__topic-item--selected');
          this.selectedTopics.add(topicValue);
        } else {
          item.classList.remove('trainingbook-step-10__topic-item--selected');
        }
      });
    }*/
  }

  // Check if configurator was completed and restore data only if it was
  checkAndRestoreData() {
    try {
      const completed = localStorage.getItem('trainingbook_configurator_completed');
      if (completed === 'true') {
        this.loadSavedFormData();
      } else {
      }
    } catch (e) {
      console.warn('TrainingbookConfigDialog: Could not check completion status:', e);
    }
  }

  // Render the final SVG in all tee-mockup-zoomable elements
  renderFinalSVGInTeeMockupZoomable() {
    try {
      
      // Get the final SVG from the configuration
      const coverContainer = this.querySelector('#trainingbook_final_preview_container');
      const generatedCoverSVG = coverContainer ? coverContainer.querySelector('svg') : null;
      
      if (!generatedCoverSVG) {
        console.warn('TrainingbookConfigDialog: No final SVG found to render');
        return;
      }
      
      // Find all tee-mockup-zoomable elements
      const teeMockupZoomableElements = [document.querySelector('.product__media-list .product__media-item'),document.querySelector(".thumbnail-list .thumbnail-list__item button")];
      
      teeMockupZoomableElements.forEach((element, index) => {
        try {
          // Clone the SVG to avoid conflicts
          const svgClone = generatedCoverSVG.cloneNode(true);
          
          // Ensure the SVG fits properly
          svgClone.setAttribute('width', '100%');
          svgClone.setAttribute('height', '100%');
          svgClone.style.cssText = 'width: 100%; height: 100%; object-fit: contain;';
          
          // Find the printarea wrapper within this element
            // Clear existing content and add the SVG
            element.innerHTML = svgClone.outerHTML;
            element.classList.add('trainingbuch-preview-added');

        } catch (elementError) {
          console.warn(`TrainingbookConfigDialog: Error rendering SVG in element ${index + 1}:`, elementError);
        }
      });

      this.saveOrder();
      document.querySelector("#wimmelbuchAtcButton").style.display = "block";
      document.querySelectorAll("wimmelbuch-config-button").forEach(btn => btn.setCompleted());

    } catch (e) {
      console.error('TrainingbookConfigDialog: Error in renderFinalSVGInTeeMockupZoomable:', e);
    }
  }

  // Mark configurator as completed
  markConfiguratorCompleted() {
    try {
      localStorage.setItem('trainingbook_configurator_completed', 'true');
      
      // After marking as completed, ensure the final SVG is rendered in tee-mockup-zoomable elements
      this.renderFinalSVGInTeeMockupZoomable();
    } catch (e) {
      console.warn('TrainingbookConfigDialog: Could not mark configurator as completed:', e);
    }
  }

  // Helper methods to restore data from localStorage
  restoreStep8DataFromStorage() {
    try {
      const stored = localStorage.getItem('trainingbook_form_data');
      if (stored) {
        const formData = JSON.parse(stored);
        if (formData.step8) {
          this.restoreStep8Data(formData.step8);
        }
      }
    } catch (e) {
      console.warn('TrainingbookConfigDialog: Could not restore step 8 data:', e);
    }
  }

  restoreStep9DataFromStorage() {
    try {
      const stored = localStorage.getItem('trainingbook_form_data');
      if (stored) {
        const formData = JSON.parse(stored);
        if (formData.step9) {
          this.restoreStep9Data(formData.step9);
        }
      }
    } catch (e) {
      console.warn('TrainingbookConfigDialog: Could not restore step 9 data:', e);
    }
  }

  restoreStep10DataFromStorage() {
    try {
      const stored = localStorage.getItem('trainingbook_form_data');
      if (stored) {
        const formData = JSON.parse(stored);
        if (formData.step10) {
          this.restoreStep10Data(formData.step10);
        }
      }
    } catch (e) {
      console.warn('TrainingbookConfigDialog: Could not restore step 10 data:', e);
    }
  }

  // Methods that check completion status before restoring data
  restoreStep8DataIfCompleted() {
    try {
      const completed = localStorage.getItem('trainingbook_configurator_completed');
      if (completed === 'true') {
        setTimeout(() => this.restoreStep8DataFromStorage(), 0);
      }
    } catch (e) {
      console.warn('TrainingbookConfigDialog: Could not check completion status for step 8:', e);
    }
  }

  restoreStep9DataIfCompleted() {
    try {
      const completed = localStorage.getItem('trainingbook_configurator_completed');
      if (completed === 'true') {
        setTimeout(() => this.restoreStep9DataFromStorage(), 0);
      }
    } catch (e) {
      console.warn('TrainingbookConfigDialog: Could not check completion status for step 9:', e);
    }
  }

  restoreStep10DataIfCompleted() {
    try {
      const completed = localStorage.getItem('trainingbook_configurator_completed');
      if (completed === 'true') {
        setTimeout(() => this.restoreStep10DataFromStorage(), 0);
      }
    } catch (e) {
      console.warn('TrainingbookConfigDialog: Could not check completion status for step 10:', e);
    }
  }


}

if (!customElements.get('trainingbook-config-dialog')) {
  customElements.define('trainingbook-config-dialog', TrainingbookConfigDialog);
}

})();